require("core-js/modules/es6.array.is-array");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.string.starts-with");

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.string.ends-with");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.string.repeat");

require("core-js/modules/es6.regexp.replace");

require("core-js/modules/es6.string.iterator");

require("core-js/modules/es6.array.from");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.array.find-index");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.filter");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.string.link");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.array.reduce");

require("core-js/modules/es6.regexp.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.string.small");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.set-prototype-of");

!function (e, n) {
  "object" == typeof exports && "undefined" != typeof module ? n(exports, require("styled-components"), require("@tinacms/styles"), require("react"), require("react-color"), require("color-string"), require("react-select"), require("@tinacms/icons"), require("react-dropzone"), require("prosemirror-view"), require("prosemirror-state"), require("prosemirror-dropcursor"), require("prosemirror-gapcursor"), require("prosemirror-history"), require("prosemirror-keymap"), require("prosemirror-inputrules"), require("react-dom"), require("prosemirror-commands"), require("react-dismissible"), require("prosemirror-schema-list"), require("prosemirror-model"), require("prosemirror-tables"), require("prosemirror-transform")) : "function" == typeof define && define.amd ? define(["exports", "styled-components", "@tinacms/styles", "react", "react-color", "color-string", "react-select", "@tinacms/icons", "react-dropzone", "prosemirror-view", "prosemirror-state", "prosemirror-dropcursor", "prosemirror-gapcursor", "prosemirror-history", "prosemirror-keymap", "prosemirror-inputrules", "react-dom", "prosemirror-commands", "react-dismissible", "prosemirror-schema-list", "prosemirror-model", "prosemirror-tables", "prosemirror-transform"], n) : n((e = e || self)["@tinacms/fields"] = {}, e.styled, e.styles, e.React, e.reactColor, e.colorString, e.SelectBase, e.icons, e.reactDropzone, e.prosemirrorView, e.prosemirrorState, e.prosemirrorDropcursor, e.prosemirrorGapcursor, e.prosemirrorHistory, e.prosemirrorKeymap, e.prosemirrorInputrules, e.reactDom, e.prosemirrorCommands, e.reactDismissible, e.prosemirrorSchemaList, e.prosemirrorModel, e.prosemirrorTables, e.prosemirrorTransform);
}(this, function (e, s, n, f, t, r, l, u, p, h, d, a, c, m, g, b, i, v, k, o, y, w, x) {
  "use strict";

  var C = "default" in s ? s["default"] : s,
      M = "default" in l ? l["default"] : l,
      _2 = function _(e, n) {
    return (_2 = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (e, n) {
      e.__proto__ = n;
    } || function (e, n) {
      for (var t in n) {
        n.hasOwnProperty(t) && (e[t] = n[t]);
      }
    })(e, n);
  };

  function E(e, n) {
    function t() {
      this.constructor = e;
    }

    _2(e, n), e.prototype = null === n ? Object.create(n) : (t.prototype = n.prototype, new t());
  }

  var _z = function z() {
    return (_z = Object.assign || function (e) {
      for (var n, t = 1, r = arguments.length; t < r; t++) {
        for (var o in n = arguments[t]) {
          Object.prototype.hasOwnProperty.call(n, o) && (e[o] = n[o]);
        }
      }

      return e;
    }).apply(this, arguments);
  };

  function A(e, n) {
    var t = {};

    for (var r in e) {
      Object.prototype.hasOwnProperty.call(e, r) && n.indexOf(r) < 0 && (t[r] = e[r]);
    }

    if (null != e && "function" == typeof Object.getOwnPropertySymbols) {
      var o = 0;

      for (r = Object.getOwnPropertySymbols(e); o < r.length; o++) {
        n.indexOf(r[o]) < 0 && Object.prototype.propertyIsEnumerable.call(e, r[o]) && (t[r[o]] = e[r[o]]);
      }
    }

    return t;
  }

  function S(e, n) {
    return Object.defineProperty ? Object.defineProperty(e, "raw", {
      value: n
    }) : e.raw = n, e;
  }

  var T,
      L,
      I,
      O,
      D,
      B,
      F,
      R,
      P = s.css(L = L || S(["\n  padding: ", ";\n  border-radius: ", ";\n  background: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  position: relative;\n  background-color: ", ";\n  transition: all 85ms ease-out;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0;\n  outline: none;\n  box-shadow: 0 0 0 2px ", ";\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: ", ";\n  }\n\n  ", ";\n"], ["\n  padding: ", ";\n  border-radius: ", ";\n  background: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  position: relative;\n  background-color: ", ";\n  transition: all 85ms ease-out;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0;\n  outline: none;\n  box-shadow: 0 0 0 2px ", ";\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: ", ";\n  }\n\n  ", ";\n"]), n.padding("small"), n.radius("small"), n.color.grey(0), n.font.size(2), n.color.grey(), n.color.grey(2), function (e) {
    return e.error ? n.color.error() : "transparent";
  }, n.color.grey(3), function (e) {
    return e.error ? n.color.error() : n.color.primary();
  }, n.font.size(2), n.color.grey(3), function (e) {
    return e.small && s.css(T = T || S(["\n      font-size: ", ";\n      padding: 0.5rem ", ";\n    "], ["\n      font-size: ", ";\n      padding: 0.5rem ", ";\n    "]), n.font.size(1), n.padding("small"));
  }),
      N = C.input(I = I || S(["\n  ", "\n"], ["\n  ", "\n"]), P),
      q = C.input(O = O || S(["\n  ", "\n"], ["\n  ", "\n"]), P),
      $ = C.textarea(D = D || S(["\n  ", ";\n  resize: vertical;\n  height: 10rem;\n"], ["\n  ", ";\n  resize: vertical;\n  height: 10rem;\n"]), P);
  (R = F = F || {}).Hex = "hex", R.RGB = "rgb";

  function j(e) {
    if (!e) return null;
    var n = r.get(e);
    if (!n) return null;
    var t = n.value;
    return {
      r: t[0],
      g: t[1],
      b: t[2],
      a: t[3]
    };
  }

  var W,
      H,
      V,
      G,
      U,
      K = ((B = {})[F.RGB] = {
    getLabel: function getLabel(e) {
      return "R" + e.r + " G" + e.g + " B" + e.b;
    },
    getValue: function getValue(e) {
      var n = [e.r, e.g, e.b, e.a];
      return r.to.rgb(n);
    },
    parse: j
  }, B[F.Hex] = {
    getLabel: function getLabel(e) {
      return function (e) {
        return "#" + ((1 << 24) + (e.r << 16) + (e.g << 8) + e.b).toString(16).slice(1);
      }(e);
    },
    getValue: function getValue(e) {
      var n = [e.r, e.g, e.b, e.a];
      return r.to.hex(n);
    },
    parse: j
  }, B),
      Z = C(function (e) {
    var n = e.colorRGBA,
        t = e.colorFormat,
        r = (e.unselectable, A(e, ["colorRGBA", "colorFormat", "unselectable"]));
    return f.createElement("div", _z({}, r), f.createElement("div", {
      className: "swatch-inner"
    }, n ? K[t].getLabel(n) : "Click to add color"));
  })(H = H || S(["\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  cursor: pointer;\n  width: 100%;\n  margin: 0;\n\n  > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: ", ";\n    font-weight: bold;\n\n    width: 100%;\n    height: 2.5rem;\n    border-radius: ", ";\n    box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.075);\n    background: ", ";\n    color: ", ";\n    transition: all ", " ease-out;\n  }\n\n  &:hover {\n    > div {\n      opacity: 0.6;\n    }\n  }\n"], ["\n  background: ", ";\n  border-radius: ", ";\n  box-shadow: ", ";\n  cursor: pointer;\n  width: 100%;\n  margin: 0;\n\n  > div {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    font-size: ", ";\n    font-weight: bold;\n\n    width: 100%;\n    height: 2.5rem;\n    border-radius: ", ";\n    box-shadow: inset 0 0 1px 1px rgba(0, 0, 0, 0.075);\n    background: ", ";\n    color: ", ";\n    transition: all ", " ease-out;\n  }\n\n  &:hover {\n    > div {\n      opacity: 0.6;\n    }\n  }\n"]), n.color.grey(2), n.radius("big"), n.shadow("small"), n.font.size(1), n.radius("big"), function (e) {
    return e.colorRGBA ? "rgba(" + e.colorRGBA.r + ", " + e.colorRGBA.g + ", " + e.colorRGBA.b + ", " + e.colorRGBA.a + ")" : "#fff";
  }, function (e) {
    return function (e) {
      return !e || 186 < .299 * e.r + .587 * e.g + .114 * e.b ? "#000000" : "#ffffff";
    }(e.colorRGBA);
  }, n.timing("short")),
      Q = s.keyframes(V = V || S(["\n  0% {\n    transform: translate3d(-50%, 5px, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  }\n"], ["\n  0% {\n    transform: translate3d(-50%, 5px, 0) scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  }\n"])),
      Y = C.div(G = G || S(["\n  position: absolute;\n  left: 50%;\n  transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  transform-origin: 50% -0.5rem;\n  animation: ", " 85ms ease-out both 1;\n  z-index: 900;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 2px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 1rem;\n    height: 0.8rem;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: white;\n    z-index: 100;\n  }\n"], ["\n  position: absolute;\n  left: 50%;\n  transform: translate3d(-50%, 5px, 0) scale3d(1, 1, 1);\n  transform-origin: 50% -0.5rem;\n  animation: ", " 85ms ease-out both 1;\n  z-index: 900;\n  &:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    left: 50%;\n    margin-top: 2px;\n    transform: translate3d(-50%, -100%, 0);\n    width: 1rem;\n    height: 0.8rem;\n    clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n    background-color: white;\n    z-index: 100;\n  }\n"]), Q),
      J = C.div(U = U || S(["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 800;\n"], ["\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 100vh;\n  z-index: 800;\n"])),
      X = "transparent",
      ee = (E(ne, W = f.Component), Object.defineProperty(ne.prototype, "colorFormat", {
    get: function get() {
      return (this.props.colorFormat || F.Hex).toLowerCase();
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(ne.prototype, "colorRGBA", {
    get: function get() {
      return this.props.input.value ? K[this.colorFormat].parse(this.props.input.value) : null;
    },
    enumerable: !0,
    configurable: !0
  }), ne.prototype.render = function () {
    return f.createElement(f.Fragment, null, f.createElement(Z, {
      onClick: this.handleClick,
      colorRGBA: this.colorRGBA,
      colorFormat: this.colorFormat
    }), this.state.displayColorPicker ? f.createElement(f.Fragment, null, f.createElement(Y, null, f.createElement(t.SketchPicker, {
      presetColors: this.presetColors.concat([X]),
      color: this.colorRGBA || {
        r: 0,
        g: 0,
        b: 0,
        a: 0
      },
      onChange: this.handleChange,
      disableAlpha: !0,
      width: "240px"
    }), " "), f.createElement(J, {
      onClick: this.handleClose
    })) : null, " ");
  }, ne.defaultProps = {
    colorFormat: F.Hex
  }, ne);

  function ne() {
    var t = null !== W && W.apply(this, arguments) || this;
    return t.presetColors = ["#D0021B", "#F5A623", "#F8E71C", "#8B572A", "#7ED321", "#417505", "#BD10E0", "#9013FE", "#4A90E2", "#50E3C2", "#B8E986", "#000000", "#4A4A4A", "#9B9B9B", "#FFFFFF"], t.state = {
      displayColorPicker: !1
    }, t.handleClick = function () {
      t.setState({
        displayColorPicker: !t.state.displayColorPicker
      });
    }, t.handleClose = function () {
      t.setState({
        displayColorPicker: !1
      });
    }, t.handleChange = function (e) {
      var n = e.hex === X ? null : _z({}, e.rgb, {
        a: 1
      });
      t.props.input.onChange(n ? K[t.colorFormat].getValue(n) : null);
    }, t;
  }

  function te(e) {
    return l.components.DropdownIndicator ? f.createElement(l.components.DropdownIndicator, _z({}, e), f.createElement(u.ChevronDownIcon, null)) : null;
  }

  function re(e) {
    var n = e.innerProps;
    return f.createElement("span", _z({
      style: he
    }, n));
  }

  function oe(e) {
    return f.createElement(l.components.MultiValueRemove, _z({}, e), f.createElement(u.CloseIcon, null));
  }

  function ie(e) {
    var n = e.innerProps,
        t = n.ref,
        r = A(n, ["ref"]);
    return f.createElement("div", _z({
      style: ge
    }, r, {
      ref: t
    }), f.createElement(u.CloseIcon, null));
  }

  var ae,
      se,
      le,
      ce,
      de = C.div(ae = ae || S(["\n  display: inline-block;\n  position: relative;\n  width: 40px;\n  height: 20px;\n  margin: 0;\n"], ["\n  display: inline-block;\n  position: relative;\n  width: 40px;\n  height: 20px;\n  margin: 0;\n"])),
      ue = C.label(se = se || S(["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  width: 3rem;\n  height: 1.75rem;\n  pointer-events: ", ";\n"], ["\n  background: none;\n  color: inherit;\n  padding: 0;\n  opacity: ", ";\n  outline: none;\n  width: 3rem;\n  height: 1.75rem;\n  pointer-events: ", ";\n"]), function (e) {
    return e.disabled ? "0.4" : "1";
  }, function (e) {
    return e.disabled ? "none" : "inherit";
  }),
      pe = C.div(le = le || S(["\n  position: relative;\n  width: 3rem;\n  height: 1.75rem;\n  border-radius: ", ";\n  background-color: white;\n  border: 1px solid ", ";\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: ", ";\n    left: 2px;\n    top: 50%;\n    width: calc(1.75rem - 6px);\n    height: calc(1.75rem - 6px);\n    background: ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n  }\n"], ["\n  position: relative;\n  width: 3rem;\n  height: 1.75rem;\n  border-radius: ", ";\n  background-color: white;\n  border: 1px solid ", ";\n  pointer-events: none;\n  margin-left: -2px;\n  span {\n    position: absolute;\n    border-radius: ", ";\n    left: 2px;\n    top: 50%;\n    width: calc(1.75rem - 6px);\n    height: calc(1.75rem - 6px);\n    background: ", ";\n    transform: translate3d(", ", -50%, 0);\n    transition: all 150ms ease-out;\n  }\n"]), n.radius(), n.color.grey(2), n.radius(), function (e) {
    return e.checked ? n.color.primary() : n.color.grey(3);
  }, function (e) {
    return e.checked ? "1.25rem" : "0";
  }),
      me = C.input(ce = ce || S(["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 3rem;\n  height: 1.75rem;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n"], ["\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 3rem;\n  height: 1.75rem;\n  opacity: 0;\n  margin: 0;\n  cursor: ", ";\n"]), function (e) {
    return e.disabled ? "not-allowed" : "pointer";
  }),
      fe = {
    control: function control(e, n) {
      return _z({}, e, {
        fontSize: "0.9rem",
        minHeight: 32,
        borderWidth: "1px",
        borderColor: n.isFocused ? "#333" : "#dedede",
        boxShadow: null
      });
    },
    option: function option(e, n) {
      return _z({}, e, {
        display: "flex",
        alignItems: "center",
        height: 26,
        fontSize: "0.9rem",
        color: n.isSelected ? "black" : "#666",
        backgroundColor: n.isDisabled ? null : n.isSelected ? "#f3f3f3" : n.isFocused ? "#fafafa" : null
      });
    },
    singleValue: function singleValue(e, n) {
      return _z({}, e, {
        opacity: n.isDisabled ? .4 : 1,
        transition: "opacity 300ms",
        color: "black"
      });
    },
    dropdownIndicator: function dropdownIndicator(e) {
      return _z({}, e, {
        cursor: "pointer"
      });
    },
    multiValue: function multiValue(e) {
      return _z({}, e, {
        borderRadius: 4.8,
        backgroundColor: "#f3f3f3"
      });
    },
    multiValueLabel: function multiValueLabel(e) {
      return _z({}, e);
    },
    multiValueRemove: function multiValueRemove(e, n) {
      return _z({}, e, {
        borderRadius: "0 0.3rem 0.3rem 0",
        backgroundColor: n.isFocused ? "#333" : null,
        padding: "0 0.4rem",
        cursor: "pointer"
      });
    },
    noOptionsMessage: function noOptionsMessage(e) {
      return _z({}, e, {
        fontSize: "0.8rem",
        padding: "1rem 0"
      });
    }
  },
      he = {
    alignSelf: "stretch",
    backgroundColor: "#dedede",
    marginBottom: 4,
    marginTop: 4,
    width: 1
  },
      ge = {
    fontSize: "0.8rem",
    cursor: "pointer",
    padding: "0.5rem"
  };

  var be,
      ve,
      ke,
      ye,
      we,
      xe = C.div(be = be || S(["\n  border-radius: ", ";\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  cursor: pointer;\n"], ["\n  border-radius: ", ";\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  outline: none;\n  cursor: pointer;\n"]), n.radius("small")),
      Ce = C.div(ve = ve || S(["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 0.75rem 0;\n  font-size: ", ";\n  font-weight: 500;\n  transition: all 85ms ease-out;\n  &:hover {\n    opacity: 0.6;\n  }\n"], ["\n  text-align: center;\n  border-radius: ", ";\n  background-color: ", ";\n  color: ", ";\n  line-height: 1.35;\n  padding: 0.75rem 0;\n  font-size: ", ";\n  font-weight: 500;\n  transition: all 85ms ease-out;\n  &:hover {\n    opacity: 0.6;\n  }\n"]), n.radius("small"), n.color.grey(2), n.color.grey(4), n.font.size(2)),
      Me = C.img(ke = ke || S(["\n  max-width: 100%;\n  border-radius: ", ";\n  transition: opacity ", " ease-out;\n  margin: 0;\n  display: block;\n"], ["\n  max-width: 100%;\n  border-radius: ", ";\n  transition: opacity ", " ease-out;\n  margin: 0;\n  display: block;\n"]), n.radius("small"), n.timing("short")),
      _e = C(n.IconButton)(ye = ye || S(["\n  top: 0.5rem;\n  right: 0.5rem;\n  position: absolute;\n  &:not(:hover) {\n    fill: ", ";\n    background-color: transparent;\n    border-color: transparent;\n  }\n"], ["\n  top: 0.5rem;\n  right: 0.5rem;\n  position: absolute;\n  &:not(:hover) {\n    fill: ", ";\n    background-color: transparent;\n    border-color: transparent;\n  }\n"]), n.color.grey()),
      Ee = C.div(we = we || S(["\n  background-color: ", ";\n  position: relative;\n  border-radius: ", ";\n  overflow: hidden;\n  background-color: ", ";\n  &:hover {\n    ", " {\n      opacity: 0.6;\n    }\n  }\n"], ["\n  background-color: ", ";\n  position: relative;\n  border-radius: ", ";\n  overflow: hidden;\n  background-color: ", ";\n  &:hover {\n    ", " {\n      opacity: 0.6;\n    }\n  }\n"]), n.color.grey(4), n.radius("small"), n.color.grey(8), Me);

  function ze(e) {
    return new RegExp("(^|[^" + e + "])" + e + "([^\r\n\t\f" + e + " ](.*[^\r\n\t\f" + e + " ])?)" + e);
  }

  var Ae = function Ae(e) {
    return new RegExp("" + e + e + "([^\r\n\t\f" + e + "} ](.*[^\r\n\t\f" + e + " ])?)" + e + e);
  },
      Se = Ae("\\*"),
      Te = ze("\\*"),
      Le = Ae("~"),
      Ie = ze("_"),
      Oe = ze("`");

  function De(e) {
    var n,
        t,
        r = [];
    return (n = e.nodes.blockquote) && r.push(function (e) {
      return b.wrappingInputRule(/^\s*>\s$/, e);
    }(n)), (n = e.nodes.ordered_list) && r.push(function (e) {
      return b.wrappingInputRule(/^(\d+)\.\s$/, e, function (e) {
        return {
          order: +e[1]
        };
      }, function (e, n) {
        return n.childCount + n.attrs.order == +e[1];
      });
    }(n)), (n = e.nodes.bullet_list) && r.push(function (e) {
      return b.wrappingInputRule(/^\s*([-+*])\s$/, e);
    }(n)), (n = e.nodes.code_block) && r.push(function (e) {
      return b.textblockTypeInputRule(/^```([a-zA-Z]*)? $/, e, function (e) {
        var n = e[1];
        return n ? {
          params: n
        } : {};
      });
    }(n)), (n = e.nodes.heading) && r.push(function (e, n) {
      return b.textblockTypeInputRule(new RegExp("^(#{1," + n + "})\\s$"), e, function (e) {
        return {
          level: e[1].length
        };
      });
    }(n, 6)), (n = e.nodes.horizontal_rule) && r.push(function (o) {
      return new b.InputRule(/^(---|___|\*\*\*)$/, function (e, n, t, r) {
        return e.tr.replaceRangeWith(t, r, o.create());
      });
    }(n)), (t = e.marks.strong) && (r.push(function (e) {
      return Be(Se, e, {});
    }(t)), r.push(function (e) {
      return Be(Ae("_"), e, {});
    }(t))), (t = e.marks.s) && r.push(function (e) {
      return Be(Le, e, {});
    }(t)), (t = e.marks.em) && (r.push(function (e) {
      return Fe(Te, e, {});
    }(t)), r.push(function (e) {
      return Fe(Ie, e, {});
    }(t))), (t = e.marks.code) && r.push(function (e) {
      return Fe(Oe, e, {});
    }(t)), r;
  }

  function Be(e, l, c) {
    return new b.InputRule(e, function (e, n, t, r) {
      var o = c instanceof Function ? c(n) : c,
          i = e.tr;

      if (n[1]) {
        var a = t + n[0].indexOf(n[1]),
            s = a + n[1].length;
        s < r && i["delete"](s, r), t < a && i["delete"](t, a), r = t + n[1].length;
      }

      return i.addMark(t, r, l.create(o)), i.removeStoredMark(l), i;
    });
  }

  function Fe(e, n, t) {
    var o = function (p, m) {
      return function (e, n, t, r, o) {
        var i = m instanceof Function ? m(t) : m,
            a = e.tr,
            s = t[1].length;

        if (t[2]) {
          var l = r + 1 + s,
              c = l + t[2].length,
              d = [l - 1, l],
              u = [c, c + (function (e, n) {
            try {
              return e.doc.textBetween(n + 1, n + 2);
            } catch (e) {
              return "";
            }
          }(e, c) ? 0 : 1)];
          a["delete"].apply(a, u), a["delete"].apply(a, d), o = r + t[2].length + s;
        }

        return a.addMark(r + s, o, p.create(i)), a.removeStoredMark(p), n && n(a), a;
      };
    }(n, t);

    return new b.InputRule(e, function (e, n, t, r) {
      return o(e, null, n, t, r);
    });
  }

  function Re(e) {
    var n,
        t,
        r = e.mark,
        o = e.Icon,
        i = e.tooltip,
        a = e.defaultAttrs,
        s = e.selectionOnly,
        l = void 0 !== s && s,
        c = e.noMix,
        d = void 0 === c ? [] : c;
    return E(u, t = f.Component), u.prototype.markType = function (e) {
      return this.props.view.state.schema.marks[e];
    }, Object.defineProperty(u.prototype, "active", {
      get: function get() {
        return this.markIsActive(r);
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(u.prototype, "disabled", {
      get: function get() {
        return l ? !!this.props.view.state.selection.$cursor || this.inCodeBlock || this.incompatibleMarksAreActive : this.inCodeBlock || this.incompatibleMarksAreActive;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(u.prototype, "inCodeBlock", {
      get: function get() {
        var e = this.props.view;
        return e.state.selection.$from.node(e.state.selection.$from.depth).type === e.state.schema.nodes.code_block;
      },
      enumerable: !0,
      configurable: !0
    }), Object.defineProperty(u.prototype, "incompatibleMarksAreActive", {
      get: function get() {
        return d.map(this.markIsActive).reduce(function (e, n) {
          return n || e;
        }, !1);
      },
      enumerable: !0,
      configurable: !0
    }), u.prototype.render = function () {
      return this.markType(r) ? f.createElement(Ln, {
        "data-tooltip": i,
        "data-side": "top",
        onClick: this.onClick,
        active: this.active,
        disabled: this.disabled
      }, f.createElement(o, null)) : null;
    }, (n = u).displayName = r + "Control", n;

    function u() {
      var s = null !== t && t.apply(this, arguments) || this;
      return s.markIsActive = function (e) {
        var n = s.props.view.state,
            t = s.markType(e),
            r = n.selection,
            o = r.from,
            i = r.$from,
            a = r.to;
        return r.empty ? !!t.isInSet(n.storedMarks || i.marks()) : n.doc.rangeHasMark(o, a, t);
      }, s.onClick = function () {
        if (!s.disabled) {
          var e = s.props.view,
              n = e.state,
              t = e.dispatch;
          n.selection.$cursor && l || (v.toggleMark(s.markType(r), a)(n, t), s.props.view.focus());
        }
      }, s;
    }
  }

  function Pe(e) {
    var n,
        t = e.Component,
        r = e.children,
        o = e.command,
        i = e.typeName,
        a = e.attrs;
    return E(s, n = f.Component), Object.defineProperty(s.prototype, "active", {
      get: function get() {
        if (!i) return !1;
        var e = this.props.view.state.selection.$from,
            n = e.node(e.depth),
            t = n.type.name === i,
            r = !a || n.attrs.level === a.level;
        return t && r;
      },
      enumerable: !0,
      configurable: !0
    }), s.prototype.render = function () {
      return f.createElement(Dn, {
        onClick: this.onClick,
        disabled: !this.canDo(),
        active: this.active
      }, f.createElement(t, null, r));
    }, s;

    function s() {
      var e = null !== n && n.apply(this, arguments) || this;
      return e.canDo = function () {
        return o(e.props.view.state);
      }, e.onClick = function () {
        o(e.props.view.state, e.props.view.dispatch), e.props.view.focus(), e.props.onClick();
      }, e;
    }
  }

  function Ne(e, n) {
    var t = e.selection.$cursor;
    if (!t) return !1;
    var r = e.doc.nodeAt(Math.max(t.pos - 1, 0));
    return !!r && r.type == e.schema.nodes.heading && !r.textContent.length && (n && n(e.tr.replaceRangeWith(t.pos - 1, t.pos + r.nodeSize - 1, e.schema.nodes.paragraph.create()).setSelection(d.Selection.near(e.doc.resolve(t.pos - 1)))), !0);
  }

  function qe(p, m, f, h) {
    return function (e, n) {
      var t = e.selection,
          r = t.from,
          o = t.to,
          i = null,
          a = -1;
      if (e.doc.nodesBetween(r, o, function (e, n) {
        return !i && (e.isTextblock && (i = e, a = n), !0);
      }), !i || a < 0) return !1;
      var s = e.doc.resolve(a),
          l = s.index(),
          c = e.selection.$head.parent.attrs.level == m.level,
          d = c ? f : p,
          u = c ? h : m;
      return !!s.parent.canReplaceWith(l, l + 1, d) && (n && n(e.tr.setBlockType(r, o, d, u).scrollIntoView()), !0);
    };
  }

  var $e,
      je = (E(We, $e = f.Component), We.prototype.render = function () {
    var e,
        n = this,
        t = this.props,
        r = t.view,
        o = t.frame;
    return o && (e = o.document), f.createElement(In, null, f.createElement(Ln, {
      "data-tooltip": "Heading",
      onClick: this.toggle,
      active: this.state.active
    }, f.createElement(u.HeadingIcon, null)), f.createElement(On, {
      open: this.state.active
    }, f.createElement(k.Dismissible, {
      click: !0,
      escape: !0,
      disabled: !this.state.active,
      onDismiss: function onDismiss() {
        n.toggle();
      },
      document: e
    }, f.createElement(rn, {
      view: r,
      onClick: this.toggle
    }), f.createElement(on, {
      view: r,
      onClick: this.toggle
    }), f.createElement(an, {
      view: r,
      onClick: this.toggle
    }), f.createElement(sn, {
      view: r,
      onClick: this.toggle
    }), f.createElement(ln, {
      view: r,
      onClick: this.toggle
    }), f.createElement(cn, {
      view: r,
      onClick: this.toggle
    }))));
  }, We);

  function We() {
    var e = null !== $e && $e.apply(this, arguments) || this;
    return e.state = {
      active: !1
    }, e.toggle = function () {
      return e.setState(function (e) {
        return {
          active: !e.active
        };
      });
    }, e.blockQuote = function () {
      return v.wrapIn(e.props.view.state.schema.nodes.blockquote)(e.props.view.state, e.props.view.dispatch);
    }, e.lift = function () {
      return v.lift(e.props.view.state, e.props.view.dispatch);
    }, e;
  }

  function He(t) {
    return function (e, n) {
      return qe(e.schema.nodes.heading, {
        level: t
      }, e.schema.nodes.paragraph, null)(e, n);
    };
  }

  var Ve,
      Ge,
      Ue,
      Ke,
      Ze,
      Qe,
      Ye = C.div(Ve = Ve || S(["\n  font-size: 40px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"], ["\n  font-size: 40px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"])),
      Je = C.div(Ge = Ge || S(["\n  font-size: 34px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"], ["\n  font-size: 34px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"])),
      Xe = C.div(Ue = Ue || S(["\n  font-size: 26px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"], ["\n  font-size: 26px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"])),
      en = C.div(Ke = Ke || S(["\n  font-size: 21px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"], ["\n  font-size: 21px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"])),
      nn = C.div(Ze = Ze || S(["\n  font-size: 18px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"], ["\n  font-size: 18px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"])),
      tn = C.div(Qe = Qe || S(["\n  font-size: 16px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"], ["\n  font-size: 16px;\n  white-space: nowrap;\n  line-height: 1;\n  display: block;\n"])),
      rn = Pe({
    Component: Ye,
    children: "Heading 1",
    command: He(1),
    typeName: "heading",
    attrs: {
      level: 1
    }
  }),
      on = Pe({
    Component: Je,
    children: "Heading 2",
    command: He(2),
    typeName: "heading",
    attrs: {
      level: 2
    }
  }),
      an = Pe({
    Component: Xe,
    children: "Heading 3",
    command: He(3),
    typeName: "heading",
    attrs: {
      level: 3
    }
  }),
      sn = Pe({
    Component: en,
    children: "Heading 4",
    command: He(4),
    typeName: "heading",
    attrs: {
      level: 4
    }
  }),
      ln = Pe({
    Component: nn,
    children: "Heading 5",
    command: He(5),
    typeName: "heading",
    attrs: {
      level: 5
    }
  }),
      cn = Pe({
    Component: tn,
    children: "Heading 6",
    command: He(6),
    typeName: "heading",
    attrs: {
      level: 6
    }
  });

  function dn(e, n) {
    var t = o.liftListItem(e.schema.nodes.list_item);
    return o.wrapInList(e.schema.nodes.bullet_list)(e, n) || t(e, n);
  }

  function un(e, n) {
    var t = o.liftListItem(e.schema.nodes.list_item);
    return o.wrapInList(e.schema.nodes.ordered_list)(e, n) || t(e, n);
  }

  function pn(e) {
    var n = e.view,
        t = e.bottom,
        r = void 0 !== t && t,
        o = e.frame,
        i = e.theme,
        a = f.useCallback(function (e) {
      e.stopPropagation(), e.preventDefault();
    }, []);
    return f.createElement(s.ThemeProvider, {
      theme: i
    }, f.createElement(Tn, {
      onMouseDown: a
    }, f.createElement(je, {
      view: n,
      frame: o
    }), f.createElement(fn, {
      view: n
    }), f.createElement(hn, {
      view: n
    }), f.createElement(gn, {
      view: n
    }), f.createElement(bn, {
      view: n
    }), f.createElement(En, {
      view: n,
      bottom: r
    }), f.createElement(zn, {
      view: n,
      bottom: r
    }), f.createElement(An, {
      view: n,
      bottom: r
    }), f.createElement(Sn, {
      view: n,
      bottom: r
    })));
  }

  function mn(t, e, n, r, o) {
    return void 0 === o && (o = !0), E(i, a = f.Component), i.prototype.render = function () {
      return f.createElement(Ln, {
        "data-tooltip": r,
        onClick: this.onClick,
        bottom: this.props.bottom,
        disabled: !this.canDo()
      }, f.createElement(e, null));
    }, i;

    function i() {
      var n = null !== a && a.apply(this, arguments) || this;
      return n.onClick = function () {
        if (n.canDo()) {
          var e = n.props.view;
          t(e.state, e.dispatch), o && e.focus();
        }
      }, n.canDo = function () {
        return t(n.props.view.state);
      }, n;
    }

    var a;
  }

  var fn = Re({
    mark: "strong",
    Icon: u.BoldIcon,
    tooltip: "Bold"
  }),
      hn = Re({
    mark: "em",
    Icon: u.ItalicIcon,
    tooltip: "Italic"
  }),
      gn = Re({
    mark: "underline",
    Icon: u.UnderlineIcon,
    tooltip: "Underline"
  }),
      bn = Re({
    mark: "link",
    Icon: u.LinkIcon,
    tooltip: "Link",
    selectionOnly: !0,
    defaultAttrs: {
      href: "",
      title: "",
      editing: "editing",
      creating: "creating"
    },
    noMix: ["code"]
  });

  var vn,
      kn,
      yn,
      wn,
      xn,
      Cn,
      Mn,
      _n,
      En = mn(function (e, n) {
    return v.wrapIn(e.schema.nodes.blockquote)(e, n);
  }, u.QuoteIcon, 0, "Blockquote"),
      zn = mn(function (e, n) {
    return v.setBlockType(e.schema.nodes.code_block)(e, n);
  }, u.CodeIcon, 0, "Codeblock", !1),
      An = mn(dn, u.UnorderedListIcon, 0, "Unordered List"),
      Sn = mn(un, u.OrderedListIcon, 0, "Ordered List"),
      Tn = C.div(vn = vn || S(["\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  background-color: white;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  border: 1px solid ", ";\n  overflow: visible;\n  display: flex;\n  flex: 0 0 auto;\n  z-index: 10;\n  margin: 0 0 0.75rem 0;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  width: 100%;\n  background-color: white;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  border: 1px solid ", ";\n  overflow: visible;\n  display: flex;\n  flex: 0 0 auto;\n  z-index: 10;\n  margin: 0 0 0.75rem 0;\n"]), n.radius(), n.color.grey(2)),
      Ln = C.button(wn = wn || S(["\n  flex: 1 0 auto;\n  background-color: ", ";\n  color: ", ";\n  fill: ", ";\n  border: none;\n  outline: none;\n  padding: 0.375rem;\n  margin: 0;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: rgba(53, 50, 50, 0.09);\n  }\n  &:active {\n    color: #0084ff;\n    fill: #0084ff;\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  &:not(:last-child) {\n    border-right: 1px solid rgba(53, 50, 50, 0.09);\n  }\n  &:first-child {\n    padding-left: 0.75rem;\n    border-radius: ", " 0 0 ", ";\n  }\n  &:last-child {\n    padding-right: 0.75rem;\n    border-radius: 0 1.5rem 1.5rem 0;\n  }\n  svg {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n  ", ";\n  ", ";\n"], ["\n  flex: 1 0 auto;\n  background-color: ", ";\n  color: ", ";\n  fill: ", ";\n  border: none;\n  outline: none;\n  padding: 0.375rem;\n  margin: 0;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  &:hover {\n    background-color: rgba(53, 50, 50, 0.09);\n  }\n  &:active {\n    color: #0084ff;\n    fill: #0084ff;\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n  &:not(:last-child) {\n    border-right: 1px solid rgba(53, 50, 50, 0.09);\n  }\n  &:first-child {\n    padding-left: 0.75rem;\n    border-radius: ", " 0 0 ", ";\n  }\n  &:last-child {\n    padding-right: 0.75rem;\n    border-radius: 0 1.5rem 1.5rem 0;\n  }\n  svg {\n    width: 1.25rem;\n    height: 1.25rem;\n  }\n  ", ";\n  ", ";\n"]), function (e) {
    return e.active ? "rgba(53, 50, 50, 0.05)" : "transparent";
  }, function (e) {
    return e.active ? "#0084ff" : n.color.grey(8);
  }, function (e) {
    return e.active ? "#0084ff" : n.color.grey(8);
  }, n.radius(), n.radius(), function (e) {
    return e.active && s.css(kn = kn || S(["\n      color: #0084ff;\n      fill: #0084ff;\n      background-color: rgba(53, 50, 50, 0.05);\n    "], ["\n      color: #0084ff;\n      fill: #0084ff;\n      background-color: rgba(53, 50, 50, 0.05);\n    "]));
  }, function (e) {
    return e.disabled && s.css(yn = yn || S(["\n      pointer-events: none;\n      color: #d1d1d1;\n      fill: #d1d1d1;\n    "], ["\n      pointer-events: none;\n      color: #d1d1d1;\n      fill: #d1d1d1;\n    "]));
  }),
      In = C.div(xn = xn || S(["\n  position: relative;\n"], ["\n  position: relative;\n"])),
      On = C.div(Mn = Mn || S(["\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  left: 0;\n  bottom: -0.5rem;\n  transform: translate3d(0, 100%, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(48, 48, 48, 0.1);\n  background-color: white;\n  overflow: hidden;\n  ", ";\n"], ["\n  border-radius: ", ";\n  border: 1px solid #efefef;\n  display: block;\n  position: absolute;\n  left: 0;\n  bottom: -0.5rem;\n  transform: translate3d(0, 100%, 0) scale3d(0.5, 0.5, 1);\n  opacity: 0;\n  pointer-events: none;\n  transition: all 85ms ease-out;\n  transform-origin: 0 0;\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12), 0px 4px 8px rgba(48, 48, 48, 0.1);\n  background-color: white;\n  overflow: hidden;\n  ", ";\n"]), n.radius(), function (e) {
    return e.open && s.css(Cn = Cn || S(["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 100%, 0) scale3d(1, 1, 1);\n    "], ["\n      opacity: 1;\n      pointer-events: all;\n      transform: translate3d(0, 100%, 0) scale3d(1, 1, 1);\n    "]));
  }),
      Dn = C.div(_n = _n || S(["\n  display: block;\n  padding: 0.5rem 1rem;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  &:first-child {\n    padding-top: ", ";\n  }\n  &:last-child {\n    padding-bottom: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n    fill: ", ";\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n"], ["\n  display: block;\n  padding: 0.5rem 1rem;\n  transition: all 85ms ease-out;\n  cursor: pointer;\n  &:first-child {\n    padding-top: ", ";\n  }\n  &:last-child {\n    padding-bottom: ", ";\n  }\n  &:hover {\n    background-color: ", ";\n    color: ", ";\n  }\n  &:active {\n    color: ", ";\n    fill: ", ";\n    background-color: rgba(53, 50, 50, 0.05);\n  }\n"]), n.padding("small"), n.padding("small"), n.color.grey(1), n.color.primary(), n.color.primary(), n.color.primary()),
      Bn = f.createContext(null),
      Fn = (Rn.prototype.render = function () {
    i.render(f.createElement(Pn, {
      frame: this.frame
    }, f.createElement(Bn.Provider, {
      value: this.translator
    }, f.createElement(pn, {
      view: this.view,
      bottom: this.bottom,
      format: "markdown",
      frame: this.frame,
      theme: this.theme
    }))), this.dom);
  }, Rn.prototype.update = function () {
    this.render();
  }, Rn.prototype.destroy = function () {
    i.unmountComponentAtNode(this.dom), this.dom.remove();
  }, Rn);

  function Rn(e, n, t, r, o) {
    this.view = e, this.translator = n, this.bottom = t, this.frame = r, this.theme = o, this.dom = document.createElement("div"), this.render();
  }

  var Pn = function Pn(e) {
    var n = e.frame,
        t = e.children;
    return n ? f.createElement(s.StyleSheetManager, {
      target: n.document.head
    }, t) : f.createElement(f.Fragment, null, t);
  };

  var Nn = "undefined" != typeof navigator && /Mac/.test(navigator.platform);
  var qn,
      $n = (E(jn, qn = f.Component), jn.prototype.componentDidMount = function () {
    document.addEventListener("keydown", this.onEscapeCancel);
  }, jn.prototype.componentWillUnmount = function () {
    document.removeEventListener("keydown", this.onEscapeCancel);
  }, jn.prototype.componentWillReceiveProps = function (e) {
    var n = e.href,
        t = e.title;
    this.setState(function () {
      return {
        href: n,
        title: t
      };
    });
  }, jn.prototype.render = function () {
    var e = this.props,
        n = e.removeLink,
        t = e.style,
        r = void 0 === t ? {} : t,
        o = this.state,
        i = o.href,
        a = o.title;
    return f.createElement(Yn, {
      style: _z({}, r)
    }, f.createElement(Jn, null, "Title"), f.createElement(Xn, {
      placeholder: "Enter Title",
      autoFocus: !0,
      type: "text",
      value: a,
      onChange: this.setTitle,
      onKeyPress: this.onEnterSave
    }), f.createElement(Jn, null, "URL"), f.createElement(Xn, {
      placeholder: "Enter URL",
      autoFocus: !0,
      type: "text",
      value: i,
      onChange: this.setHref,
      onKeyPress: this.onEnterSave
    }), f.createElement(et, null, f.createElement(tt, {
      onClick: n
    }, "Delete"), f.createElement(nt, {
      onClick: this.save
    }, "Save")));
  }, jn);

  function jn() {
    var t = null !== qn && qn.apply(this, arguments) || this;
    return t.state = {
      href: t.props.href || "",
      title: t.props.title || ""
    }, t.setHref = function (e) {
      var n = e.target.value;
      return t.setState(function () {
        return {
          href: n
        };
      });
    }, t.setTitle = function (e) {
      var n = e.target.value;
      return t.setState(function () {
        return {
          title: n
        };
      });
    }, t.save = function () {
      return t.props.onChange(t.state);
    }, t.onEnterSave = function (e) {
      "Enter" === e.key && t.save();
    }, t.onEscapeCancel = function (e) {
      27 === e.keyCode && t.props.cancel();
    }, t;
  }

  var Wn,
      Hn,
      Vn,
      Gn,
      Un,
      Kn,
      Zn,
      Qn = s.keyframes(Wn = Wn || S(["\n  0% {\n    transform: scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n"], ["\n  0% {\n    transform: scale3d(0.5,0.5,1)\n  }\n  100% {\n    transform: scale3d(1, 1, 1);\n  }\n"])),
      Yn = C.div(Hn = Hn || S(["\n  background-color: #f6f6f9;\n  position: relative;\n  height: max-content;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  animation: ", " 85ms ease-out both 1;\n  overflow: visible;\n  padding: 0.75rem;\n  z-index: 10;\n"], ["\n  background-color: #f6f6f9;\n  position: relative;\n  height: max-content;\n  border-radius: ", ";\n  border: 1px solid ", ";\n  filter: drop-shadow(0px 4px 8px rgba(48, 48, 48, 0.1))\n    drop-shadow(0px 2px 3px rgba(0, 0, 0, 0.12));\n  transform-origin: 50% 0;\n  animation: ", " 85ms ease-out both 1;\n  overflow: visible;\n  padding: 0.75rem;\n  z-index: 10;\n"]), n.radius("small"), n.color.grey(2), Qn),
      Jn = C.label(Vn = Vn || S(["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: ", ";\n  margin-bottom: 0.2rem;\n"], ["\n  display: block;\n  font-size: ", ";\n  font-weight: 600;\n  letter-spacing: 0.01em;\n  color: ", ";\n  margin-bottom: 0.2rem;\n"]), n.font.size(1), n.color.grey(8)),
      Xn = C.input(Gn = Gn || S(["\n  position: relative;\n  background-color: white;\n  border-radius: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0 0 0.5rem 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px #0084ff;\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: #cfd3d7;\n  }\n"], ["\n  position: relative;\n  background-color: white;\n  border-radius: ", ";\n  font-size: ", ";\n  line-height: 1.35;\n  transition: all 85ms ease-out;\n  padding: 0.5rem 0.75rem;\n  border: 1px solid ", ";\n  width: 100%;\n  margin: 0 0 0.5rem 0;\n  outline: none;\n  box-shadow: 0 0 0 2px transparent;\n\n  &:hover {\n    box-shadow: 0 0 0 2px ", ";\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px #0084ff;\n  }\n\n  &::placeholder {\n    font-size: ", ";\n    color: #cfd3d7;\n  }\n"]), n.radius("small"), n.font.size(1), n.color.grey(2), n.color.grey(3), n.font.size(2)),
      et = C.div(Un = Un || S(["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 0.25rem;\n"], ["\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 0.25rem;\n"])),
      nt = C.button(Kn = Kn || S(["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: #0084ff;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: ", ";\n  padding: 0.5rem 1.25rem;\n  margin-left: 0.5rem;\n  &:hover {\n    background-color: #2296fe;\n  }\n  &:active {\n    background-color: #0574e4;\n  }\n"], ["\n  text-align: center;\n  border: 0;\n  border-radius: ", ";\n  box-shadow: 0px 2px 3px rgba(0, 0, 0, 0.12);\n  background-color: #0084ff;\n  color: white;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 85ms ease-out;\n  font-size: ", ";\n  padding: 0.5rem 1.25rem;\n  margin-left: 0.5rem;\n  &:hover {\n    background-color: #2296fe;\n  }\n  &:active {\n    background-color: #0574e4;\n  }\n"]), n.radius(), n.font.size(0)),
      tt = C(nt)(Zn = Zn || S(["\n  background-color: white;\n  border: 1px solid ", ";\n  color: #0084ff;\n  &:hover {\n    background-color: #f6f6f9;\n    opacity: 1;\n  }\n"], ["\n  background-color: white;\n  border: 1px solid ", ";\n  color: #0084ff;\n  &:hover {\n    background-color: #f6f6f9;\n    opacity: 1;\n  }\n"]), n.color.grey(2));

  function rt(e, n) {
    var t = e.schema.marks.link,
        r = e.selection.$cursor,
        o = e.tr;
    if (!r) return !1;
    var i = e.doc.nodeAt(r.pos);
    if (!i || !t.isInSet(i.marks)) return !1;

    if (n) {
      var a = function (n, e) {
        var t = (window.$cursor = n).index(),
            r = n.indexAfter();
        t === n.parent.childCount && (t--, r--);

        function o(e) {
          return i.isInSet(n.parent.child(e).marks);
        }

        var i = e.isInSet(n.parent.child(t).marks);

        for (; 0 < t && o(t - 1);) {
          t--;
        }

        for (; r < n.parent.childCount && o(r);) {
          r++;
        }

        for (var a = n.start(), s = a, l = 0; l < r; l++) {
          var c = n.parent.child(l).nodeSize;
          l < t && (a += c), s += c;
        }

        return {
          from: a,
          to: s,
          mark: i
        };
      }(r, t),
          s = a.from,
          l = a.to,
          c = a.mark,
          d = _z({}, c ? c.attrs : {}, {
        editing: "editing",
        creating: ""
      });

      o.addMark(s, l, t.create(d)), n(o.scrollIntoView());
    }

    return !0;
  }

  function ot(e, n) {
    var o = [],
        i = e.schema.marks.link;
    if (e.doc.descendants(function (e, n) {
      var t = i.isInSet(e.marks);

      if (t && "editing" == t.attrs.editing) {
        var r = _z({}, t.attrs, {
          editing: "",
          creating: ""
        });

        o.push({
          from: n,
          to: n + e.nodeSize,
          mark: i.create(r)
        });
      }
    }), !o.length) return !1;

    if (n) {
      var a = e.tr;
      o.forEach(function (e) {
        var n = e.from,
            t = e.to,
            r = e.mark;
        return a.addMark(n, t, r);
      }), n(a);
    }

    return !0;
  }

  function it(e, n) {
    var t = e.schema.nodes.horizontal_rule;
    return n && n(e.tr.replaceSelectionWith(t.create()).scrollIntoView()), !0;
  }

  var at = (st.prototype.component = function () {
    var e = function (e, n, t) {
      var r = e.offsetWidth,
          o = e.offsetLeft,
          i = n.parentElement.offsetWidth,
          a = n.offsetLeft,
          s = o - a + r / 2 - t / 2;
      return s < -a ? "-0.5rem" : i < s + t ? "calc(" + (s - (s + t - i)) + "px + 0.5rem)" : s + "px";
    }(this.clickTarget, this.renderTarget, 240),
        n = "calc(2rem + " + (this.clickTarget.offsetTop - this.renderTarget.offsetTop) + "px)",
        t = function (e, n) {
      var t = e.offsetWidth,
          r = e.offsetLeft,
          o = n.offsetLeft;
      return r - o + t / 2 + "px";
    }(this.clickTarget, this.renderTarget);

    return f.createElement(ct, {
      frame: this.frame
    }, f.createElement(s.ThemeProvider, {
      theme: this.theme
    }, f.createElement(f.Fragment, null, f.createElement(dt, {
      offset: t,
      top: n
    }), f.createElement($n, {
      style: {
        left: e,
        top: n,
        minWidth: "240px"
      },
      removeLink: this.removeLink,
      onChange: this.onChange,
      href: this.href,
      title: this.title,
      cancel: this.cancel
    }))));
  }, Object.defineProperty(st.prototype, "href", {
    get: function get() {
      return this.clickTarget.getAttribute("href");
    },
    enumerable: !0,
    configurable: !0
  }), Object.defineProperty(st.prototype, "title", {
    get: function get() {
      return this.clickTarget.getAttribute("title");
    },
    enumerable: !0,
    configurable: !0
  }), st);

  function st(e, n, t, r) {
    var o = this;
    this.renderTarget = e, this.view = n, this.frame = t, this.theme = r, this.clickTarget = null, this.render = function (e) {
      o.clickTarget = e, i.render(o.component(), o.renderTarget);
    }, this.unmount = function () {
      return i.unmountComponentAtNode(o.renderTarget);
    }, this.cancel = function () {
      return ot(o.view.state, o.view.dispatch);
    }, this.removeLink = function () {
      return function (e, n) {
        if (n) {
          var i = e.schema.marks.link,
              a = e.tr;
          e.doc.descendants(function (e, n) {
            var t = i.isInSet(e.marks);

            if (t && t.attrs.editing) {
              var r = n,
                  o = r + e.nodeSize;
              a.removeMark(r, o, t);
            }
          }), n(a.scrollIntoView());
        }

        return !0;
      }(o.view.state, o.view.dispatch);
    }, this.onChange = function (e) {
      !function (e, n, i) {
        if (n) {
          var a = e.schema.marks.link,
              s = e.tr;
          e.doc.descendants(function (e, n) {
            var t = a.isInSet(e.marks);

            if (t && t.attrs.editing) {
              var r = n,
                  o = r + e.nodeSize;
              s.addMark(r, o, a.create(i));
            }
          }), n(s.scrollIntoView());
        }
      }(o.view.state, o.view.dispatch, _z({}, e, {
        editing: "",
        creating: ""
      }));
    };
  }

  var lt,
      ct = function ct(e) {
    var n = e.frame,
        t = e.children;
    return n ? f.createElement(s.StyleSheetManager, {
      target: n.document.head
    }, t) : f.createElement(f.Fragment, null, t);
  },
      dt = C.div(lt = lt || S(["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  margin-top: 3px;\n  transform: translate3d(-50%, -100%, 0);\n  width: 1rem;\n  height: 0.8rem;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #f6f6f9;\n  z-index: 100;\n"], ["\n  position: absolute;\n  top: ", ";\n  left: ", ";\n  margin-top: 3px;\n  transform: translate3d(-50%, -100%, 0);\n  width: 1rem;\n  height: 0.8rem;\n  clip-path: polygon(50% 0%, 0% 100%, 100% 100%);\n  background-color: #f6f6f9;\n  z-index: 100;\n"]), function (e) {
    return e.top;
  }, function (e) {
    return e.offset;
  });

  var ut = (pt.prototype.shouldStopEditing = function (e) {
    var n = this.renderTarget.contains(e),
        t = this.linkBeingEdited && "creating" === this.linkBeingEdited.getAttribute("creating"),
        r = t && !this.skippedLinkControlClick;
    return this.skippedLinkControlClick = !!t, this.visible && !n && !r;
  }, pt.prototype.isValidLink = function (e) {
    for (var n, t = e; !n && t;) {
      "a" === t.tagName.toLowerCase() ? n = t : t = t.parentElement;
    }

    var r = this.view.state.selection.$cursor;
    return n && r ? n : null;
  }, pt.prototype.update = function (e) {
    this.view = e, this.linkBeingEdited = this.view.dom.querySelector("a[editing='editing']"), !this.linkBeingEdited && this.visible && this.unmountLinkForm(), this.linkBeingEdited && !this.visible && this.renderLinkForm(this.linkBeingEdited);
  }, pt.prototype.renderLinkForm = function (e) {
    this.visible = !0, function (e, n) {
      var t = e.state.tr;
      t.setMeta("type", "tinacms/render"), t.setMeta("clickTarget", n), e.dispatch(t);
    }(this.view, e);
  }, pt);

  function pt(e, n, t, r) {
    var i = this;
    this.view = e, this.schema = n, this.renderTarget = t, this.extraDoc = r, this.visible = !1, this.linkBeingEdited = null, this.skippedLinkControlClick = !1, this.destroy = function () {
      document.removeEventListener("click", i.handleClick), i.extraDoc && i.extraDoc.addEventListener("click", i.handleClick), window.removeEventListener("resize", i.unmountLinkForm), i.renderTarget.parentElement.removeChild(i.renderTarget);
    }, this.handleClick = function (e) {
      var n = e.target,
          t = i.view.dom.contains(n),
          r = i.isValidLink(n);
      if (i.shouldStopEditing(n) && ot(i.view.state, i.view.dispatch), t && r) if (e.preventDefault(), e.stopPropagation(), e.metaKey) {
        var o = r.getAttribute("href");
        window.open(o || void 0, "_blank");
      } else rt(i.view.state, i.view.dispatch);
    }, this.unmountLinkForm = function () {
      i.visible = !1, function (e) {
        var n = e.state.tr;
        n.setMeta("type", "tinacms/unmount"), e.dispatch(n);
      }(i.view);
    }, document.addEventListener("click", this.handleClick), r && r.addEventListener("click", this.handleClick), window.addEventListener("resize", this.unmountLinkForm);
  }

  var mt = /\bhttps?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:;%_\+.,~#?&//=]*)/g;

  function ft(t, r, o) {
    var i,
        a,
        s = function (e) {
      var n = document.createElement("div");
      return n.setAttribute("id", e), n.style.width = "0", n.style.height = "0", n;
    }("links");

    return new d.Plugin({
      filterTransaction: function filterTransaction(e) {
        switch (e.getMeta("type")) {
          case "tinacms/render":
            return i.render(e.getMeta("clickTarget")), !1;

          case "tinacms/unmount":
            return i.unmount(), !1;

          default:
            return !0;
        }
      },
      view: function view(e) {
        var n;
        return function (e, n) {
          if (!n.parentElement) throw new Error("Sibling must not be an orphan!");
          n.parentElement.insertBefore(e, n);
        }(s, e.dom), i = new at(s, e, r, o), r && (n = r.document), new ut(e, t, s, n);
      },
      props: {
        transformPasted: function transformPasted(e) {
          return a ? e : new y.Slice(gt(e.content), e.openStart, e.openEnd);
        },
        handleKeyDown: function handleKeyDown(e, n) {
          return a = n.shiftKey, !1;
        }
      }
    });
  }

  var ht = /\.(jpe?g|png)/,
      gt = function gt(e) {
    var u = [];
    return e.forEach(function (i) {
      if (i.isText) {
        for (var a = i.text, s = 0, e = void 0, l = i.type.schema.marks.link, c = i.type.schema.nodes.image, d = []; e = mt.exec(a);) {
          var n = e.index,
              t = n + e[0].length;
          d.push({
            start: n,
            end: t
          });
        }

        d.forEach(function (e) {
          var n,
              t = e.start,
              r = e.end;
          0 < t && u.push(i.cut(s, t));
          var o = a.slice(t, r);
          ht.test(o) ? (n = {
            src: o,
            title: "",
            alt: ""
          }, u.push(c.create(n))) : (n = {
            href: o,
            title: o
          }, 1 === d.length && (n.editing = "editing", n.creating = "creating"), u.push(i.cut(t, r).mark(l.create(n).addToSet(i.marks)))), s = r;
        }), s < a.length && u.push(i.cut(s));
      } else u.push(i.copy(gt(i.content)));
    }), y.Fragment.fromArray(u);
  };

  function bt(e, n, t, r, o, i) {
    return d.EditorState.create({
      schema: e,
      doc: n.nodeFromString(r),
      plugins: [function (e) {
        return b.inputRules({
          rules: De(e)
        });
      }(e), g.keymap(function (t, e) {
        var r = _z({}, v.baseKeymap);

        function o(e, n) {
          r[e] && (n = v.chainCommands(n, r[e])), r[e] = n;
        }

        return o("Enter", v.chainCommands(v.createParagraphNear, v.liftEmptyBlock, v.splitBlock)), function (e, n) {
          return n.filter(function (n) {
            return function (e) {
              return e.__type === n;
            };
          }(e));
        }("wysiwyg:keymap", e).forEach(function (e) {
          var n = !1;
          e.unlessMac && Nn && (n = !0), e.ifMark && !t.marks[e.ifMark] && (n = !0), e.ifNode && !t.nodes[e.ifNode] && (n = !0), e.onCondition && !e.onCondition(t) && (n = !0), n || o(e.name, e.command(t));
        }), r;
      }(e, t)), m.history(), ft(e, o, i), a.dropCursor({
        width: 2,
        color: "rgb(33, 224, 158)"
      }), c.gapCursor(), function (r, o, i, a) {
        return new d.Plugin({
          view: function view(e) {
            var n = new Fn(e, r, o, i, a),
                t = e.dom.parentNode;
            return t.parentElement.insertBefore(n.dom, t), n;
          }
        });
      }(n, !1, o, i)]
    });
  }

  function vt() {}

  var kt = (yt.prototype.serialize = function (e, n) {
    void 0 === n && (n = {});
    var t = new xt(this.nodes, this.marks, n);
    return t.renderContent(e), t.out;
  }, yt);

  function yt(e, n) {
    this.nodes = e, this.marks = n;
  }

  var wt,
      xt = (Ct.prototype.flushClose = function (e) {
    if (this.closed) {
      if (this.atBlank() || (this.out += "\n"), null == e && (e = 2), 1 < e) {
        var n = this.delim,
            t = /\s+$/.exec(n);
        t && (n = n.slice(0, n.length - t[0].length));

        for (var r = 1; r < e; r++) {
          this.out += n + "\n";
        }
      }

      this.closed = !1;
    }
  }, Ct.prototype.wrapBlock = function (e, n, t, r) {
    var o = this.delim;
    this.write(n || e), this.delim += e, r(), this.delim = o, this.closeBlock(t);
  }, Ct.prototype.atBlank = function () {
    return /(^|\n)$/.test(this.out);
  }, Ct.prototype.ensureNewLine = function () {
    this.atBlank() || (this.out += "\n");
  }, Ct.prototype.write = function (e) {
    this.flushClose(), this.delim && this.atBlank() && (this.out += this.delim), e && (this.out += e);
  }, Ct.prototype.closeBlock = function (e) {
    this.closed = e;
  }, Ct.prototype.text = function (e, n) {
    for (var t = e.split("\n"), r = 0; r < t.length; r++) {
      var o = this.atBlank() || this.closed;
      this.write(), this.out += !1 !== n ? this.esc(t[r], o) : t[r], r != t.length - 1 && (this.out += "\n");
    }
  }, Ct.prototype.render = function (e, n, t) {
    if ("number" == typeof n) throw new Error("!");
    this.nodes[e.type.name](this, e, n, t);
  }, Ct.prototype.renderContent = function (r) {
    var o = this;
    r.forEach(function (e, n, t) {
      return o.render(e, r, t);
    });
  }, Ct.prototype.renderInline = function (k) {
    function e(e, n, t) {
      void 0 === t && (t = 0);
      var r = e ? e.marks : [],
          o = r.findIndex(function (e) {
        return "code" === e.type.name;
      });
      0 <= o && 1 < r.length && (r = r.slice(0, o).concat(r.slice(o + 1, r.length), [r[o]]));
      var i = x;

      if (x = "", e && e.isText && r.some(function (e, n, t) {
        var r = y.marks[e.type.name];
        return !(!r || !r.expelEnclosingWhitespace);
      }) && /^(\s*)(.*?)(\s*)$/.test(e.text || "")) {
        var a = Array.from(/^(\s*)(.*?)(\s*)$/.exec(e.text || "") || []),
            s = a[1],
            l = a[2],
            c = a[3];
        i += s, x = c, (s || c) && ((e = l ? e.withText(l) : null) || (r = w));
      }

      var d = r.length && r[r.length - 1],
          u = d && !1 === y.marks[d.type.name].escape,
          p = r.length - (u ? 1 : 0);

      e: for (var m = 0; m < p; m++) {
        var f = r[m];
        if (!y.marks[f.type.name].mixable) break;

        for (var h = 0; h < w.length; h++) {
          var g = w[h];
          if (!y.marks[g.type.name].mixable) break;

          if (f.eq(g)) {
            h < m ? r = r.slice(0, h).concat(f).concat(r.slice(h, m)).concat(r.slice(m + 1, p)) : m < h && (r = r.slice(0, m).concat(r.slice(m + 1, h)).concat(f).concat(r.slice(h, p)));
            continue e;
          }
        }
      }

      for (var b = 0; b < Math.min(w.length, p) && r[b].eq(w[b]);) {
        ++b;
      }

      for (; b < w.length;) {
        y.text(y.markString(w.pop(), !1, e), !1);
      }

      if (i && y.text(i), e) {
        for (; w.length < p;) {
          var v = r[w.length];
          w.push(v), y.text(y.markString(v, !0, e), !1);
        }

        u && e.isText && d ? y.text(y.markString(d, !1, e) + e.text + y.markString(d, !0, e), !1) : y.render(e, k, t);
      }
    }

    var y = this,
        w = [],
        x = "";
    k.forEach(e), e(null);
  }, Ct.prototype.renderList = function (r, o, i) {
    var a = this;
    this.closed && this.closed.type == r.type ? this.flushClose(3) : this.inTightList && this.flushClose(1);
    var s = this.options.tightLists,
        e = this.inTightList;
    this.inTightList = !!s, r.forEach(function (e, n, t) {
      t && s && a.flushClose(1), a.wrapBlock(o, i(t), r, function () {
        return a.render(e, r, t);
      });
    }), this.inTightList = e;
  }, Ct.prototype.esc = function (e, n) {
    return e = e.replace(/[`\\~\[\]]/g, "\\$&"), n && (e = e.replace(/^[#\-*+]/, "\\$&").replace(/^(\d+)\./, "$1\\.")), e;
  }, Ct.prototype.quote = function (e) {
    var n = -1 == e.indexOf('"') ? '""' : -1 == e.indexOf("'") ? "''" : "()";
    return n[0] + e + n[1];
  }, Ct.prototype.repeat = function (e, n) {
    for (var t = "", r = 0; r < n; r++) {
      t += e;
    }

    return t;
  }, Ct.prototype.markString = function (e, n, t) {
    var r = this.marks[e.type.name],
        o = n ? r.open : r.close;
    return "string" == typeof o ? o : o(this, e, t);
  }, Ct.prototype.getEnclosingWhitespace = function (e) {
    return {
      leading: (e.match(/^(\s+)/) || [])[0],
      trailing: (e.match(/(\s+)$/) || [])[0]
    };
  }, Ct);

  function Ct(e, n, t) {
    this.nodes = e, this.marks = n, this.delim = this.out = "", this.closed = !1, this.inTightList = !1, this.options = t || {}, void 0 === this.options.tightLists && (this.options.tightLists = !1);
  }

  var Mt = require("lodash.get"),
      _t = ((wt = {})["text-align:left"] = "left", wt["text-align:center"] = "center", wt["text-align:right"] = "right", wt),
      Et = {
    left: ":---",
    center: ":---:",
    right: "---:"
  },
      zt = {
    blockquote: {
      block: "blockquote"
    },
    paragraph: {
      block: "paragraph"
    },
    list_item: {
      block: "list_item"
    },
    bullet_list: {
      block: "bullet_list"
    },
    ordered_list: {
      block: "ordered_list",
      getAttrs: function getAttrs(e) {
        return {
          order: +e.attrGet("order") || 1
        };
      }
    },
    heading: {
      block: "heading",
      getAttrs: function getAttrs(e) {
        return {
          level: +e.tag.slice(1)
        };
      }
    },
    code_block: {
      block: "code_block"
    },
    fence: {
      block: "code_block",
      getAttrs: function getAttrs(e) {
        return {
          params: e.info || ""
        };
      }
    },
    hr: {
      node: "horizontal_rule"
    },
    image: {
      node: "image",
      getAttrs: function getAttrs(e) {
        return {
          src: e.attrGet("src"),
          title: e.attrGet("title") || null,
          alt: e.children[0] && e.children[0].content || null,
          width: e.attrGet("width") || null,
          height: e.attrGet("height") || null
        };
      }
    },
    table: {
      block: "table"
    },
    table_row: {
      block: "table_row"
    },
    table_cell: {
      block: "table_cell",
      getAttrs: function getAttrs(e) {
        var n = "";
        if (e.attrs) for (var t = 0; t < e.attrs.length; t++) {
          "style" === e.attrs[t][0] && (n = e.attrs[t][1]);
        }
        return {
          align: _t[n]
        };
      }
    },
    table_header: {
      block: "table_header",
      getAttrs: function getAttrs(e) {
        var n = "";
        if (e.attrs) for (var t = 0; t < e.attrs.length; t++) {
          "style" === e.attrs[t][0] && (n = e.attrs[t][1]);
        }
        return {
          align: _t[n]
        };
      }
    },
    hardbreak: {
      node: "hard_break"
    },
    em: {
      mark: "em"
    },
    s: {
      mark: "s"
    },
    strong: {
      mark: "strong"
    },
    link: {
      mark: "link",
      getAttrs: function getAttrs(e) {
        return {
          href: e.attrGet("href"),
          title: e.attrGet("title") || null
        };
      }
    },
    code_inline: {
      mark: "code"
    }
  },
      At = {
    blockquote: function blockquote(e, n) {
      e.wrapBlock("> ", null, n, function () {
        return e.renderContent(n);
      });
    },
    code_block: function code_block(e, n) {
      n.attrs.params ? (e.write("```" + n.attrs.params + "\n"), e.text(n.textContent, !1), e.ensureNewLine(), e.write("```"), e.closeBlock(n)) : e.wrapBlock("    ", null, n, function () {
        return e.text(n.textContent, !1);
      });
    },
    heading: function heading(e, n) {
      /\n/.test(n.textContent) && n.attrs.level < 3 ? (e.renderInline(n), e.write("\n"), e.write(1 === n.attrs.level ? "=" : "-")) : (e.write(e.repeat("#", n.attrs.level) + " "), e.renderInline(n)), e.closeBlock(n);
    },
    horizontal_rule: function horizontal_rule(e, n) {
      e.write(n.attrs.markup || "***"), e.closeBlock(n);
    },
    bullet_list: function bullet_list(e, n) {
      e.renderList(n, "  ", function () {
        return (n.attrs.bullet || "*") + " ";
      });
    },
    ordered_list: function ordered_list(t, e) {
      var r = e.attrs.order || 1,
          o = String(r + e.childCount - 1).length,
          n = t.repeat(" ", o + 2);
      t.renderList(e, n, function (e) {
        var n = String(r + e);
        return t.repeat(" ", o - n.length) + n + ". ";
      });
    },
    list_item: function list_item(e, n) {
      e.renderContent(n);
    },
    paragraph: function paragraph(e, n, t, r) {
      e.renderInline(n), e.closeBlock(n);
    },
    image: function image(e, n) {
      var t = "";
      (n.attrs.height || n.attrs.width) && (t = " =" + (n.attrs.width || "") + "x" + (n.attrs.height || ""));
      var r = e.esc(n.attrs.alt || ""),
          o = e.esc(n.attrs.src),
          i = n.attrs.title ? " " + e.quote(n.attrs.title) : "";
      e.write("![" + r + "](" + o + i + t + ")");
    },
    hard_break: function hard_break(e, n, t, r) {
      if (t && "number" == typeof r) for (var o = r + 1; o < t.childCount; o++) {
        if (t.child(o).type != n.type) return void e.write("  \n");
      }
    },
    text: function text(e, n) {
      "string" == typeof n.text && e.text(n.text);
    },
    table: function table(i, e) {
      var a = !0;
      e.forEach(function (e) {
        var n = "table_cell" === e.content.child(0).type.name;

        if (a && n) {
          i.write("|");

          for (var t = 0; t < e.childCount; t++) {
            var r = e.content.child(t).attrs.align,
                o = Et[r] || "---";
            i.write(" " + o + " |");
          }

          i.write("\n"), a = !1;
        }

        At.table_row(i, e);
      }), i.closeBlock(e);
    },
    table_row: function table_row(e, n) {
      e.write("|"), e.renderContent(n), e.write("\n");
    },
    table_cell: function table_cell(a, e) {
      a.write(" "), e.forEach(function (e, n, t) {
        for (var r = e.text ? e.text.split("\n") : [], o = 0; o < r.length; o++) {
          var i = a.atBlank() || a.closed;
          a.write(), a.out += a.esc(r[o], i).replace(/[\|]/g, "\\$&"), o != r.length - 1 && (a.out += "\n");
        }
      }), a.write(" |");
    },
    table_header: function table_header(e, n) {
      At.table_cell(e, n);
    }
  },
      St = {
    em: {
      open: "_",
      close: "_",
      mixable: !0,
      expelEnclosingWhitespace: !0
    },
    strong: {
      open: function open(e, n, t) {
        return Mt(t, "text", "").endsWith("*") ? n.openedWith = "__" : "**";
      },
      close: function close(e, n, t) {
        if (n.openedWith) {
          var r = n.openedWith;
          return n.openedWith = null, r;
        }

        return Mt(t, "text", "").endsWith("*") ? "__" : "**";
      },
      mixable: !0,
      expelEnclosingWhitespace: !0
    },
    link: {
      open: "[",
      close: function close(e, n) {
        return "](" + e.esc(n.attrs.href) + (n.attrs.title ? " " + e.quote(n.attrs.title) : "") + ")";
      }
    },
    s: {
      open: "~~",
      close: "~~",
      mixable: !0,
      expelEnclosingWhitespace: !0
    },
    code: {
      open: "`",
      close: "`",
      escape: !1
    }
  };

  function Tt(e) {
    return new kt(function (e) {
      var n = {};
      return e.nodes.blockquote && (n.blockquote = At.blockquote), e.nodes.paragraph && (n.paragraph = At.paragraph), e.nodes.list_item && (n.list_item = At.list_item), e.nodes.bullet_list && (n.bullet_list = At.bullet_list), e.nodes.ordered_list && (n.ordered_list = At.ordered_list), e.nodes.heading && (n.heading = At.heading), e.nodes.code_block && (n.code_block = At.code_block), e.nodes.horizontal_rule && (n.horizontal_rule = At.horizontal_rule), e.nodes.image && (n.image = At.image), e.nodes.hard_break && (n.hard_break = At.hard_break), e.nodes.ordered_list && (n.ordered_list = At.ordered_list), e.nodes.bullet_list && (n.bullet_list = At.bullet_list), e.nodes.list_item && (n.list_item = At.list_item), e.nodes.table && (n.table = At.table, n.table_header = At.table_header, n.table_row = At.table_row, n.table_cell = At.table_cell), n.text = At.text, n;
    }(e), function (e) {
      return e.marks.em, e.marks.strong, e.marks.link, e.marks.code, St;
    }(e));
  }

  function Lt(e, n, t) {
    var r,
        o = n,
        i = {
      ok: !1,
      pos: n
    };

    for (r = e.charCodeAt(n); n < t && 48 <= r && r <= 57 || 37 === r;) {
      r = e.charCodeAt(++n);
    }

    return i.ok = !0, i.pos = n, i.value = Number(e.slice(o, n)), i;
  }

  function It(e, n, t) {
    var r,
        o,
        i = e.utils.isSpace,
        a = e.utils.unescapeAll,
        s = n.src,
        l = n.posMax,
        c = t,
        d = {
      ok: !1,
      pos: 0,
      lines: 0,
      str: ""
    };

    if (60 === s.charCodeAt(t)) {
      for (t++; t < l;) {
        if (10 === (r = s.charCodeAt(t)) || i(r)) return d;
        if (62 === r) return d.pos = t + 1, d.str = a(s.slice(c + 1, t)), d.ok = !0, d;
        92 === r && t + 1 < l ? t += 2 : t++;
      }

      return d;
    }

    for (o = 0; t < l;) {
      if (61 == (r = s.charCodeAt(t)) || 34 == r || 39 == r) {
        t--;
        break;
      }

      if (r < 32 || 127 === r) break;
      if (92 === r && t + 1 < l) t += 2;else {
        if (40 === r && o++, 41 === r) {
          if (0 === o) break;
          o--;
        }

        t++;
      }
    }

    return c === t || 0 !== o || (d.str = a(s.slice(c, t)), d.lines = 0, d.pos = t, d.ok = !0), d;
  }

  function Ot(y) {
    return function (e, n) {
      var t,
          r,
          o,
          i,
          a,
          s,
          l,
          c,
          d,
          u,
          p = null,
          m = null,
          f = "",
          h = e.pos,
          g = e.posMax;
      if (33 !== e.src.charCodeAt(e.pos)) return !1;
      if (91 !== e.src.charCodeAt(e.pos + 1)) return !1;
      var b = e.pos + 2,
          v = y.helpers.parseLinkLabel(e, e.pos + 1, !1);
      if (v < 0) return !1;

      if ((i = v + 1) < g && 40 === e.src.charCodeAt(i)) {
        for (i++; i < g && (32 === (r = e.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }

        if (g <= i) return !1;

        for ((s = It(y, e, u = i)).ok && (f = s.str, e.md.validateLink(f) ? i = s.pos : f = ""), u = i; i < g && (32 === (r = e.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }

        if (s = y.helpers.parseLinkTitle(e.src, i, e.posMax), i < g && u !== i && s.ok) for (l = s.str, i = s.pos; i < g && (32 === (r = e.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        } else l = "";
        if (0 <= i - 1 && 32 === (r = e.src.charCodeAt(i - 1)) && (s = function (e, n, t) {
          var r,
              o = {
            ok: !1,
            pos: 0
          };
          if (t <= n) return o;
          if (61 !== (r = e.charCodeAt(n))) return o;
          if (n++, 120 !== (r = e.charCodeAt(n)) && (r < 48 || 57 < r)) return o;
          var i = Lt(e, n, t);
          if (n = i.pos, 120 !== (r = e.charCodeAt(n))) return o;
          var a = Lt(e, ++n, t);
          return n = a.pos, o.width = i.value, o.height = a.value, o.pos = n, o.ok = !0, o;
        }(e.src, i, e.posMax)).ok) for (p = s.width, m = s.height, i = s.pos; i < g && (32 === (r = e.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }
        if (g <= i || 41 !== e.src.charCodeAt(i)) return e.pos = h, !1;
        i++;
      } else {
        if (void 0 === e.env.references) return !1;

        for (; i < g && (32 === (r = e.src.charCodeAt(i)) || 10 === r); i++) {
          ;
        }

        if (i < g && 91 === e.src.charCodeAt(i) ? (u = i + 1, 0 <= (i = y.helpers.parseLinkLabel(e, i)) ? o = e.src.slice(u, i++) : i = v + 1) : i = v + 1, o = o || e.src.slice(b, v), !(a = e.env.references[y.utils.normalizeReference(o)])) return e.pos = h, !1;
        f = a.href, l = a.title;
      }

      if (!n) {
        e.pos = b, e.posMax = v;
        var k = new e.md.inline.State(e.src.slice(b, v), e.md, e.env, d = []);
        k.md.inline.tokenize(k), (c = e.push("image", "img", 0)).attrs = t = [["src", f], ["alt", ""]], c.children = d, l && t.push(["title", l]), null !== p && t.push(["width", p]), null !== m && t.push(["height", m]);
      }

      return e.pos = i, e.posMax = g, !0;
    };
  }

  function Dt(e) {
    e.inline.ruler.before("emphasis", "image", Ot(e));
  }

  function Bt(e) {
    e.inline.ruler.before("emphasis", "link", function (v) {
      return function (e, n) {
        var t,
            r,
            o,
            i,
            a,
            s,
            l,
            c = e.md.utils.normalizeReference,
            d = e.md.utils.isSpace,
            u = "",
            p = e.pos,
            m = !0,
            f = e.pos,
            h = e.posMax;
        if (91 !== e.src.charCodeAt(e.pos)) return !1;
        var g = e.pos + 1,
            b = e.md.helpers.parseLinkLabel(e, e.pos, !0);
        if (b < 0) return !1;

        if ((i = b + 1) < h && 40 === e.src.charCodeAt(i)) {
          for (m = !1, i++; i < h && (d(r = e.src.charCodeAt(i)) || 10 === r); i++) {
            ;
          }

          if (h <= i) return !1;

          for ((a = It(v, e, p = i)).ok && (u = a.str, e.md.validateLink(u) ? i = a.pos : u = ""), p = i; i < h && (d(r = e.src.charCodeAt(i)) || 10 === r); i++) {
            ;
          }

          if (a = e.md.helpers.parseLinkTitle(e.src, i, e.posMax), i < h && p !== i && a.ok) for (l = a.str, i = a.pos; i < h && (d(r = e.src.charCodeAt(i)) || 10 === r); i++) {
            ;
          } else l = "";
          (h <= i || 41 !== e.src.charCodeAt(i)) && (m = !0), i++;
        }

        if (m) {
          if (void 0 === e.env.references) return !1;
          if (i < h && 91 === e.src.charCodeAt(i) ? (p = i + 1, 0 <= (i = e.md.helpers.parseLinkLabel(e, i)) ? o = e.src.slice(p, i++) : i = b + 1) : i = b + 1, o = o || e.src.slice(g, b), !(s = e.env.references[c(o)])) return e.pos = f, !1;
          u = s.href, l = s.title;
        }

        return n || (e.pos = g, e.posMax = b, e.push("link_open", "a", 1).attrs = t = [["href", u]], l && t.push(["title", l]), e.md.inline.tokenize(e), e.push("link_close", "a", -1)), e.pos = i, e.posMax = h, !0;
      };
    }(e));
  }

  var Ft = (Rt.prototype.top = function () {
    return this.stack[this.stack.length - 1];
  }, Rt.prototype.push = function (e) {
    this.stack.length && this.top().content.push(e);
  }, Rt.prototype.addText = function (e) {
    if (e) {
      var n,
          t = this.top().content,
          r = t[t.length - 1],
          o = this.schema.text(e, this.marks);
      r && (n = function (e, n) {
        if (e.isText && n.isText && y.Mark.sameSet(e.marks, n.marks)) return e.copy(e.text + n.text);
      }(r, o)) ? t[t.length - 1] = n : t.push(o);
    }
  }, Rt.prototype.openMark = function (e) {
    this.marks = e.addToSet(this.marks);
  }, Rt.prototype.closeMark = function (e) {
    this.marks = e.removeFromSet(this.marks);
  }, Rt.prototype.parseTokens = function (e) {
    for (var n = 0; n < e.length; n++) {
      var t = e[n],
          r = this.tokenHandlers[t.type];
      if (!r) throw new Error("Token type `" + t.type + "` not supported by Markdown parser");
      r(this, t);
    }
  }, Rt.prototype.addNode = function (e, n, t) {
    var r = e.createAndFill(n, t, this.marks);
    return r ? (this.push(r), r) : null;
  }, Rt.prototype.openNode = function (e, n) {
    this.stack.push({
      type: e,
      attrs: n,
      content: []
    });
  }, Rt.prototype.closeNode = function () {
    this.marks.length && (this.marks = y.Mark.none);
    var e = this.stack.pop();
    if (e) return this.addNode(e.type, e.attrs, e.content);
  }, Rt);

  function Rt(e, n) {
    this.schema = e, this.stack = [{
      type: e.topNodeType,
      content: []
    }], this.marks = y.Mark.none, this.tokenHandlers = n;
  }

  function Pt(e, n) {
    return e.getAttrs ? e.getAttrs(n) : e.attrs instanceof Function ? e.attrs(n) : e.attrs;
  }

  function Nt(e) {
    return "code_inline" == e || "code_block" == e || "fence" == e;
  }

  function qt(e) {
    return "\n" == e[e.length - 1] ? e.slice(0, e.length - 1) : e;
  }

  function $t() {}

  var jt = (Wt.prototype.parse = function (e) {
    var n,
        t = new Ft(this.schema, this.tokenHandlers);

    for (t.parseTokens(this.tokenizer.parse(e, {})); n = t.closeNode(), t.stack.length;) {
      ;
    }

    return n;
  }, Wt);

  function Wt(e, n, t) {
    this.tokens = t, this.schema = e, this.tokenizer = n, this.tokenHandlers = function (n, a) {
      function e(e) {
        var t = a[e];

        if (t.block) {
          var r = n.nodeType(t.block);
          Nt(e) ? s[e] = function (e, n) {
            e.openNode(r, Pt(t, n)), e.addText(qt(n.content)), e.closeNode();
          } : (s[e + "_open"] = function (e, n) {
            return e.openNode(r, Pt(t, n));
          }, s[e + "_close"] = function (e) {
            return e.closeNode();
          });
        } else if (t.node) {
          var o = n.nodeType(t.node);

          s[e] = function (e, n) {
            return e.addNode(o, Pt(t, n));
          };
        } else if (t.mark) {
          var i = n.marks[t.mark];
          Nt(e) ? s[e] = function (e, n) {
            e.openMark(i.create(Pt(t, n))), e.addText(qt(n.content)), e.closeMark(i);
          } : (s[e + "_open"] = function (e, n) {
            return e.openMark(i.create(Pt(t, n)));
          }, s[e + "_close"] = function (e) {
            return e.closeMark(i);
          });
        } else {
          if (!t.ignore) throw new RangeError("Unrecognized parsing spec " + JSON.stringify(t));
          Nt(e) ? s[e] = $t : (s[e + "_open"] = $t, s[e + "_close"] = $t);
        }
      }

      var s = Object.create(null);

      for (var t in a) {
        e(t);
      }

      return s.text = function (e, n) {
        return e.addText(n.content);
      }, s.inline = function (e, n) {
        return e.parseTokens(n.children);
      }, s.softbreak = function (e) {
        return e.addText("\n");
      }, s;
    }(e, t);
  }

  var Ht = require("markdown-it");

  function Vt(e) {
    var n = Ht({
      html: !1
    });
    return n.use(Dt), n.use(Bt), new jt(e, n, function (e) {
      var n = {};
      return e.nodes.blockquote && (n.blockquote = zt.blockquote), e.nodes.paragraph && (n.paragraph = zt.paragraph), e.nodes.list_item && (n.list_item = zt.list_item), e.nodes.bullet_list && (n.bullet_list = zt.bullet_list), e.nodes.ordered_list && (n.ordered_list = zt.ordered_list), e.nodes.heading && (n.heading = zt.heading), e.nodes.code_block && (n.code_block = zt.code_block, n.fence = zt.fence), e.nodes.horizontal_rule && (n.hr = zt.hr), e.nodes.image && (n.image = zt.image), e.nodes.hard_break && (n.hardbreak = zt.hardbreak), e.nodes.ordered_list && (n.ordered_list = zt.ordered_list), e.nodes.bullet_list && (n.bullet_list = zt.bullet_list), e.nodes.list_item && (n.list_item = zt.list_item), e.nodes.table && (n.table = zt.table, n.thead = {
        ignore: !0
      }, n.th = zt.table_header, n.tbody = {
        ignore: !0
      }, n.tr = zt.table_row, n.td = zt.table_cell), e.marks.em && (n.em = zt.em), e.marks.strong && (n.strong = zt.strong), e.marks.link && (n.link = zt.link), e.marks.code && (n.code_inline = zt.code_inline), e.marks.s && (n.s = zt.s), n;
    }(e));
  }

  var Gt,
      Ut = (E(Kt, Gt = vt), Kt.fromSchema = function (e) {
    return Kt.commonMarkFromSchema(e);
  }, Kt.commonMarkFromSchema = function (e) {
    var n = new Kt(e);
    return n.parser = Vt(e), n.serializer = Tt(e), n;
  }, Kt.prototype.nodeFromString = function (e) {
    return this.parser.parse(e);
  }, Kt.prototype.stringFromNode = function (e) {
    return this.serializer.serialize(e, {
      tightLists: !0
    });
  }, Kt);

  function Kt(e) {
    var n = Gt.call(this) || this;
    return n.parser = null, n.serializer = null, n.schema = e, n;
  }

  var Zt = "undefined" == typeof navigator,
      Qt = "undefined" != typeof navigator && /Mac/.test(navigator.platform),
      Yt = null;
  Zt || (Yt = require("codemirror"));
  var Jt = (Xt.prototype.valueChanged = function () {
    var e = er(this.node.textContent, this.cm.getValue());

    if (e) {
      var n = this.getPos() + 1,
          t = this.view.state.schema,
          r = this.view.state.tr.replaceWith(n + e.from, n + e.to, e.text ? t.text(e.text) : null);
      this.view.dispatch(r);
    }
  }, Xt.prototype.asProseMirrorSelection = function (e) {
    var n = this.getPos() + 1,
        t = this.cm.indexFromPos(this.cm.getCursor("anchor")) + n,
        r = this.cm.indexFromPos(this.cm.getCursor("head")) + n;
    return d.TextSelection.create(e, t, r);
  }, Xt.prototype.setSelection = function (e, n) {
    this.cm.focus(), this.updating = !0, this.cm.setSelection(this.cm.posFromIndex(e), this.cm.posFromIndex(n)), this.updating = !1;
  }, Xt.prototype.setupCodeMirror = function (e) {
    return Yt(null, {
      value: e.textContent,
      lineNumbers: !0,
      extraKeys: this.codeMirrorKeymap(),
      mode: e.attrs.params,
      theme: "forestry"
    });
  }, Xt.prototype.codeMirrorKeymap = function () {
    var e,
        t = this,
        r = this.view,
        n = Qt ? "Cmd" : "Ctrl";
    return Yt.normalizeKeyMap(((e = {
      Up: function Up() {
        return t.maybeEscape("line", -1);
      },
      Left: function Left() {
        return t.maybeEscape("char", -1);
      },
      Down: function Down() {
        return t.maybeEscape("line", 1);
      },
      Right: function Right() {
        return t.maybeEscape("char", 1);
      },
      Backspace: function Backspace() {
        if (!function (a) {
          return function (e, n) {
            var t = a.getCursor(),
                r = a.getValue(),
                o = !r.replace(/[ \r\n]/g, "");
            if (0 != t.line || 0 != t.ch || !o) return !1;
            var i = e.selection.$from;
            return n && n(e.tr.replaceRangeWith(i.pos - 1, i.pos + r.length + 1, e.schema.nodes.paragraph.create()).setSelection(d.Selection.near(e.doc.resolve(i.pos - 1)))), !0;
          };
        }(t.cm)(t.view.state, t.view.dispatch)) return Yt.Pass;
        t.view.focus();
      }
    })[n + "-Z"] = function () {
      return m.undo(r.state, r.dispatch);
    }, e["Shift-" + n + "-Z"] = function () {
      return m.redo(r.state, r.dispatch);
    }, e[n + "-Shift-Enter"] = function () {
      var e = t.cm.getCursor();
      if (t.cm.somethingSelected() || e.line != t.cm.firstLine()) return Yt.Pass;

      if (r.state.selection.$anchor.parentOffset) {
        var n = r.state.selection.$anchor.pos;
        r.dispatch(r.state.tr.setSelection(d.Selection.near(t.view.state.doc.resolve(n - 1), -1)));
      }

      return function (e, n) {
        var t = e.selection,
            r = t.$head,
            o = t.$anchor;
        if (!r.parent.type.spec.code || !r.sameParent(o)) return !1;
        var i = r.node(-1),
            a = r.indexAfter(-1),
            s = i.defaultContentType(a);
        if (!i.canReplaceWith(a, a, s)) return !1;

        if (n) {
          var l = r.before(),
              c = e.tr.replaceWith(l, l, s.createAndFill());
          c.setSelection(d.Selection.near(c.doc.resolve(l), -1)), n(c.scrollIntoView());
        }

        return !0;
      }(r.state, r.dispatch) && r.focus(), !0;
    }, e["Shift-Enter"] = function () {
      var e = t.cm.getCursor();
      if (t.cm.somethingSelected() || e.line != t.cm.lastLine()) return Yt.Pass;

      if (r.state.selection.$anchor.parentOffset) {
        var n = r.state.selection.$anchor.pos;
        r.dispatch(r.state.tr.setSelection(d.Selection.near(t.view.state.doc.resolve(n - 1), -1)));
      }

      return v.exitCode(r.state, r.dispatch) ? r.focus() : function (e, n) {
        var t = e.selection.$head,
            r = t.node(-1),
            o = t.indexAfter(-1),
            i = r.defaultContentType(o);

        if (n) {
          var a = t.before(),
              s = e.tr.replaceWith(a, a, i.createAndFill());
          s.setSelection(d.Selection.near(s.doc.resolve(a), 1)), n(s.scrollIntoView());
        }

        return !0;
      }(r.state, r.dispatch) ? r.focus() : void 0;
    }, e));
  }, Xt.prototype.maybeEscape = function (e, n) {
    var t = this.cm.getCursor();
    if (this.cm.somethingSelected() || t.line != (n < 0 ? this.cm.firstLine() : this.cm.lastLine()) || "char" == e && t.ch != (n < 0 ? 0 : this.cm.getLine(t.line).length)) return Yt.Pass;
    var r = this.getPos() + (n < 0 ? 0 : this.node.nodeSize),
        o = d.Selection.near(this.view.state.doc.resolve(r), n);
    if (!(o.$from.pos + 1 < this.view.state.doc.content.size)) return Yt.Pass;
    this.view.dispatch(this.view.state.tr.setSelection(o)), this.view.focus();
  }, Xt.prototype.update = function (e) {
    if (e.type != this.node.type) return !1;
    this.node = e;
    var n = er(this.cm.getValue(), e.textContent);
    return n && (this.updating = !0, this.cm.replaceRange(n.text, this.cm.posFromIndex(n.from), this.cm.posFromIndex(n.to)), this.updating = !1), !0;
  }, Xt.prototype.selectNode = function () {
    this.cm.focus();
  }, Xt.prototype.stopEvent = function () {
    return !0;
  }, Xt);

  function Xt(e, n, t) {
    var r = this;
    this.node = e, this.view = n, this.getPos = t, this.updating = !1, this.onCursorActivity = function () {
      r.updating || r.forwardSelection();
    }, this.forwardSelection = function () {
      if (r.cm.hasFocus()) {
        var e = r.view.state,
            n = r.asProseMirrorSelection(e.doc);
        n.eq(e.selection) || r.view.dispatch(e.tr.setSelection(n));
      }
    }, this.onChange = function () {
      r.updating || r.valueChanged();
    }, Zt || (this.cm = this.setupCodeMirror(e), this.dom = this.cm.getWrapperElement(), setTimeout(function () {
      return r.cm.refresh();
    }, 20), this.cm.on("cursorActivity", this.onCursorActivity), this.cm.on("changes", this.onChange), this.cm.on("focus", this.forwardSelection));
  }

  function er(e, n) {
    if (e == n) return null;

    for (var t = 0, r = e.length, o = n.length; t < r && e.charCodeAt(t) == n.charCodeAt(t);) {
      ++t;
    }

    for (; t < r && t < o && e.charCodeAt(r - 1) == n.charCodeAt(o - 1);) {
      r--, o--;
    }

    return {
      from: t,
      to: r,
      text: n.slice(t, o)
    };
  }

  var nr = {
    code_block: function code_block(e, n, t) {
      return new Jt(e, n, t);
    }
  };

  function tr(r, n, t, o) {
    void 0 === n && (n = []);

    var i = function (e) {
      return [f.useMemo(function () {
        return new y.Schema({
          nodes: function (e) {
            var n = {};
            return e.filter(function (e) {
              return "wysiwyg:schema:node" === e.__type;
            }).forEach(function (e) {
              n[e.name] = e.node;
            }), n;
          }(e),
          marks: function (e) {
            var n = {};
            return e.filter(function (e) {
              return "wysiwyg:schema:mark" === e.__type;
            }).forEach(function (e) {
              n[e.name] = e.mark;
            }), n;
          }(e)
        });
      }, [e])];
    }(n)[0],
        a = function (e) {
      return [f.useMemo(function () {
        return Ut.fromSchema(e);
      }, [e])];
    }(i)[0],
        e = f.useState(),
        s = e[0],
        l = e[1],
        c = f.useCallback(function (e) {
      e !== s && l(e);
    }, []),
        d = f.useCallback(function (e) {
      return bt(i, a, n, e, t, o);
    }, []),
        u = f.useState(),
        p = u[0],
        m = u[1];

    return f.useEffect(function () {
      if (s) {
        var t = new h.EditorView(s, {
          nodeViews: nr,
          state: d(r.value),
          dispatchTransaction: function dispatchTransaction(e) {
            var n = t.state.apply(e);
            t.updateState(n), e.docChanged && r.onChange(a.stringFromNode(e.doc));
          }
        });
        return m(t), function () {
          m(void 0), t.destroy();
        };
      }
    }, [s]), f.useEffect(function () {
      if (s && p && p.docView) {
        var e = t ? t.document : document;
        s.contains(e.activeElement) || p.updateState(d(r.value));
      }
    }, [r.value, p]), c;
  }

  var rr = {
    __type: "wysiwyg:schema:mark",
    name: "code",
    mark: {
      parseDOM: [{
        tag: "code"
      }],
      toDOM: function toDOM() {
        return ["code"];
      }
    }
  },
      or = {
    __type: "wysiwyg:schema:mark",
    name: "link",
    mark: {
      attrs: {
        href: {},
        title: {
          "default": null
        },
        editing: {
          "default": null
        },
        creating: {
          "default": null
        }
      },
      inclusive: !1,
      parseDOM: [{
        tag: "a[href]",
        getAttrs: function getAttrs(e) {
          return {
            href: e.getAttribute("href"),
            title: e.getAttribute("title"),
            editing: e.getAttribute("editing"),
            creating: e.getAttribute("creating")
          };
        }
      }],
      toDOM: function toDOM(e) {
        return ["a", e.attrs];
      },
      toDocument: function toDocument(e) {
        var n = e.attrs;
        n.editing, n.creating;
        return ["a", A(n, ["editing", "creating"])];
      }
    }
  },
      ir = {
    __type: "wysiwyg:schema:node",
    name: "doc",
    node: {
      content: "block+"
    }
  },
      ar = {
    __type: "wysiwyg:schema:node",
    name: "blockquote",
    node: {
      content: "block+",
      group: "block",
      defining: !0,
      parseDOM: [{
        tag: "blockquote"
      }],
      toDOM: function toDOM() {
        return ["blockquote", 0];
      }
    }
  },
      sr = {
    __type: "wysiwyg:schema:node",
    name: "bullet_list",
    node: {
      content: "list_item+",
      group: "block",
      attrs: {
        tight: {
          "default": !1
        }
      },
      parseDOM: [{
        tag: "ul",
        getAttrs: function getAttrs(e) {
          return {
            tight: e.hasAttribute("data-tight")
          };
        }
      }],
      toDOM: function toDOM(e) {
        return ["ul", {
          "data-tight": e.attrs.tight ? "true" : null
        }, 0];
      }
    }
  },
      lr = {
    __type: "wysiwyg:schema:node",
    name: "code_block",
    node: {
      content: "text*",
      attrs: {
        params: {
          "default": ""
        }
      },
      group: "block",
      code: !0,
      defining: !0,
      parseDOM: [{
        tag: "pre",
        preserveWhitespace: "full"
      }],
      toDOM: function toDOM() {
        return ["pre", ["code", 0]];
      }
    }
  },
      cr = {
    __type: "wysiwyg:schema:node",
    name: "hard_break",
    node: {
      inline: !0,
      group: "inline",
      selectable: !1,
      parseDOM: [{
        tag: "br"
      }],
      toDOM: function toDOM() {
        return ["br"];
      }
    }
  };

  function dr(e) {
    var n = {};

    for (var t in e) {
      e[t] && (n["forestry-" + t] = e[t]);
    }

    return n;
  }

  function ur(e) {
    var n = {};

    for (var t in e) {
      e[t] && (n[t] = e[t]);
    }

    return n;
  }

  function pr(n) {
    return function (e) {
      return _z({}, n, mr(e));
    };
  }

  function mr(e) {
    for (var n = {}, t = e.attributes, r = 0; r < t.length; r++) {
      var o = t[r];
      if (o.value) n[o.name.startsWith("forestry-") ? o.name.slice(9) : o.name] = o.value;
    }

    return n;
  }

  var fr = {
    __type: "wysiwyg:schema:node",
    name: "heading",
    node: {
      attrs: {
        level: {
          "default": 1
        },
        "class": {
          "default": ""
        },
        id: {
          "default": ""
        }
      },
      content: "inline*",
      marks: "_",
      group: "block",
      defining: !0,
      parseDOM: [{
        tag: "h1",
        getAttrs: pr({
          level: 1
        })
      }, {
        tag: "h2",
        getAttrs: pr({
          level: 2
        })
      }, {
        tag: "h3",
        getAttrs: pr({
          level: 3
        })
      }, {
        tag: "h4",
        getAttrs: pr({
          level: 4
        })
      }, {
        tag: "h5",
        getAttrs: pr({
          level: 5
        })
      }, {
        tag: "h6",
        getAttrs: pr({
          level: 6
        })
      }],
      toDocument: function toDocument(e) {
        var n = e.attrs;
        return ["h" + n.level, ur(A(n, ["level"])), 0];
      },
      toDOM: function toDOM(e) {
        var n = e.attrs;
        return ["h" + n.level, dr(A(n, ["level"])), 0];
      }
    }
  },
      hr = {
    __type: "wysiwyg:schema:node",
    name: "horizontal_rule",
    node: {
      group: "block",
      allowGapCursor: !0,
      parseDOM: [{
        tag: "hr"
      }],
      toDOM: function toDOM() {
        return ["hr"];
      }
    }
  },
      gr = {
    inline: !0,
    attrs: {
      src: {},
      align: {
        "default": null
      },
      alt: {
        "default": null
      },
      title: {
        "default": null
      },
      width: {
        "default": null
      },
      height: {
        "default": null
      }
    },
    group: "inline",
    draggable: !0,
    allowGapCursor: !0,
    parseDOM: [{
      tag: "img[src]",
      getAttrs: function getAttrs(e) {
        return {
          src: e.getAttribute("src"),
          title: e.getAttribute("title"),
          alt: e.getAttribute("alt"),
          align: function (e) {
            var n = e.getAttribute("class") || "",
                t = br.exec(n);
            if (t && 1 < t.length) return t[1];
            return null;
          }(e),
          width: e.getAttribute("width"),
          height: e.getAttribute("height")
        };
      }
    }],
    toDOM: function toDOM(e) {
      var n = {
        src: e.attrs.src
      };
      return e.attrs.title && (n.title = e.attrs.title), e.attrs.alt && (n.alt = e.attrs.alt), e.attrs.width && (n.width = e.attrs.width), e.attrs.height && (n.height = e.attrs.height), e.attrs.align && (n["class"] = "align-" + e.attrs.align), ["img", n];
    }
  },
      br = /align-([a-z]*)/;
  var vr = {
    __type: "wysiwyg:schema:node",
    name: "image",
    node: gr
  },
      kr = {
    __type: "wysiwyg:schema:node",
    name: "list_item",
    node: {
      content: "paragraph block*",
      defining: !0,
      parseDOM: [{
        tag: "li"
      }],
      toDOM: function toDOM() {
        return ["li", 0];
      }
    }
  },
      yr = {
    __type: "wysiwyg:schema:node",
    name: "ordered_list",
    node: {
      content: "list_item+",
      group: "block",
      attrs: {
        order: {
          "default": 1
        },
        tight: {
          "default": !1
        }
      },
      parseDOM: [{
        tag: "ol",
        getAttrs: function getAttrs(e) {
          return {
            order: e.hasAttribute("start") ? +(e.getAttribute("start") || 0) : 1,
            tight: e.hasAttribute("data-tight")
          };
        }
      }],
      toDOM: function toDOM(e) {
        return ["ol", {
          start: 1 == e.attrs.order ? null : e.attrs.order,
          "data-tight": e.attrs.tight ? "true" : null
        }, 0];
      }
    }
  },
      wr = {
    __type: "wysiwyg:schema:node",
    name: "paragraph",
    node: {
      content: "inline*",
      marks: "_",
      attrs: {
        "class": {
          "default": ""
        },
        id: {
          "default": ""
        }
      },
      group: "block",
      parseDOM: [{
        tag: "p",
        getAttrs: mr
      }],
      toDocument: function toDocument(e) {
        return ["p", ur(e.attrs), 0];
      },
      toDOM: function toDOM(e) {
        return ["p", dr(e.attrs), 0];
      }
    }
  },
      xr = {
    __type: "wysiwyg:schema:node",
    name: "text",
    node: {
      group: "inline"
    }
  },
      Cr = w.tableNodes({
    tableGroup: "block",
    cellContent: "inline*",
    cellAttributes: {}
  });
  Cr.table_cell = _z({}, Cr.table_cell, {
    marks: "_",
    attrs: _z({}, Cr.table_cell.attrs, {
      align: {
        "default": null
      }
    })
  }), Cr.table_header = _z({}, Cr.table_header, {
    marks: "_",
    attrs: _z({}, Cr.table_header.attrs, {
      align: {
        "default": null
      }
    })
  });
  var Mr = Object.keys(Cr).map(function (e) {
    return {
      __type: "wysiwyg:schema:node",
      name: e,
      node: Cr[e]
    };
  });

  function _r(e, n) {
    var t = function (e, n) {
      var t = e.selection,
          r = t.$from,
          o = t.$to,
          i;
      return r.blockRange(o, function (e) {
        return e.type == n;
      });
    }(e, e.schema.nodes.blockquote);

    if (!t) return !1;
    var r = x.liftTarget(t);
    return !!r && (n && n(e.tr.lift(t, r)), !0);
  }

  function Er(e) {
    var t = e.nodes.hard_break;
    return v.chainCommands(v.exitCode, function (e, n) {
      return n(e.tr.replaceSelectionWith(t.create()).scrollIntoView()), !0;
    });
  }

  function zr(n) {
    return function (e) {
      return qe(e.nodes.heading, {
        level: n
      }, e.nodes.paragraph, null);
    };
  }

  var Ar = [{
    __type: "wysiwyg:keymap",
    name: "Mod-z",
    command: function command() {
      return m.undo;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Backspace",
    command: function command() {
      return b.undoInputRule;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Shift-z",
    command: function command() {
      return m.redo;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-y",
    command: function command() {
      return m.redo;
    },
    unlessMac: !0
  }, {
    __type: "wysiwyg:keymap",
    name: "Tab",
    command: function command() {
      return function () {
        return !0;
      };
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Tab",
    command: function command() {
      return function () {
        return !0;
      };
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-b",
    ifMark: "strong",
    command: function command(e) {
      return v.toggleMark(e.marks.strong);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-i",
    ifMark: "em",
    command: function command(e) {
      return v.toggleMark(e.marks.em);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-k",
    ifMark: "link",
    command: function command(e) {
      var t = v.toggleMark(e.marks.link, {
        href: "",
        title: "",
        creating: "creating",
        editing: "editing"
      });
      return function (e, n) {
        return !e.selection.$cursor && t(e, n);
      };
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Enter",
    command: Er,
    ifNode: "hard_break"
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Enter",
    command: Er,
    ifNode: "hard_break"
  }, {
    __type: "wysiwyg:keymap",
    name: "Ctrl-Enter",
    command: Er,
    ifNode: "hard_break",
    ifMac: !0
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-1",
    command: zr(1),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-2",
    command: zr(2),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-3",
    command: zr(3),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-4",
    command: zr(4),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-5",
    command: zr(5),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-6",
    command: zr(6),
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Backspace",
    command: function command() {
      return Ne;
    },
    ifNode: "heading"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-7",
    command: function command() {
      return un;
    },
    ifNode: "ordered_list"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-8",
    command: function command() {
      return dn;
    },
    ifNode: "bullet_list"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-9",
    command: function command(e) {
      return o.liftListItem(e.nodes.list_item);
    },
    onCondition: function onCondition(e) {
      return !(!e.nodes.bullet_list && !e.nodes.ordered_list);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-0",
    command: function command(e) {
      return v.setBlockType(e.nodes.code_block);
    },
    ifNode: "code_block"
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowLeft",
    command: function command() {
      return Sr("left");
    },
    ifNode: "code_block"
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowRight",
    command: function command() {
      return Sr("right");
    },
    ifNode: "code_block"
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowUp",
    command: function command() {
      return Sr("up");
    },
    ifNode: "code_block"
  }, {
    __type: "wysiwyg:keymap",
    name: "ArrowDown",
    command: function command() {
      return Sr("down");
    },
    ifNode: "code_block"
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-0",
    ifMark: "code",
    command: function command(e) {
      return v.toggleMark(e.marks.code);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod->",
    ifNode: "blockquote",
    command: function command(e) {
      return v.wrapIn(e.nodes.blockquote);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-<",
    ifNode: "blockquote",
    command: function command() {
      return _r;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Alt-9",
    ifNode: "paragraph",
    command: function command(e) {
      return v.setBlockType(e.nodes.paragraph);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Ctrl-0",
    ifNode: "paragraph",
    command: function command(e) {
      return v.setBlockType(e.nodes.paragraph);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Mod-Enter",
    ifNode: "horizontal_rule",
    command: function command() {
      return it;
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Enter",
    ifNode: "list_item",
    command: function command(e) {
      return o.splitListItem(e.nodes.list_item);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Tab",
    ifNode: "list_item",
    command: function command(e) {
      return o.sinkListItem(e.nodes.list_item);
    }
  }, {
    __type: "wysiwyg:keymap",
    name: "Shift-Tab",
    ifNode: "list_item",
    command: function command(e) {
      return o.liftListItem(e.nodes.list_item);
    }
  }];

  function Sr(a) {
    return function (e, n, t) {
      if (e.selection.empty && t.endOfTextblock(a)) {
        var r = "left" == a || "up" == a ? -1 : 1,
            o = e.selection.$head,
            i = Selection.near(e.doc.resolve(0 < r ? o.after() : o.before()), r);
        if (i.$head && "code_block" == i.$head.parent.type.name) return n(e.tr.setSelection(i)), !0;
      }

      return !1;
    };
  }

  var Tr,
      Lr,
      Ir = [rr, {
    __type: "wysiwyg:schema:mark",
    name: "em",
    mark: {
      parseDOM: [{
        tag: "i"
      }, {
        tag: "em"
      }, {
        style: "font-style",
        getAttrs: function getAttrs(e) {
          return "italic" === e && null;
        }
      }],
      toDOM: function toDOM() {
        return ["em"];
      }
    }
  }, or, {
    __type: "wysiwyg:schema:mark",
    name: "strong",
    mark: {
      parseDOM: [{
        tag: "strong"
      }, {
        tag: "b",
        getAttrs: function getAttrs(e) {
          return "normal" != e.style.fontWeight && null;
        }
      }, {
        style: "font-weight",
        getAttrs: function getAttrs(e) {
          return /^(bold(er)?|[5-9]\d{2,})$/.test(e) && null;
        }
      }],
      toDOM: function toDOM() {
        return ["strong"];
      }
    }
  }],
      Or = [ir, wr, ar, sr, lr, cr, fr, hr, vr, kr, yr, xr].concat(Mr),
      Dr = Ir.concat(Or, Ar),
      Br = s.css(Tr = Tr || S(["\n  white-space: pre-wrap;\n\n  .CodeMirror {\n    font-family: monospace;\n    height: auto;\n    width: 100%;\n    border-radius: 0.3rem;\n    margin-bottom: 1rem;\n    color: black;\n    direction: ltr;\n  }\n\n  .CodeMirror-lines {\n    padding: 4px 0; /* Vertical padding around content */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    padding: 0 4px; /* Horizontal padding of content */\n  }\n\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    background-color: white; /* The little square between H and V scrollbars */\n  }\n\n  /* GUTTER */\n\n  .CodeMirror-gutters {\n    border-right: 1px solid #ddd;\n    background-color: #f7f7f7;\n    white-space: nowrap;\n  }\n  .CodeMirror-linenumbers {\n  }\n  .CodeMirror-linenumber {\n    padding: 0 3px 0 5px;\n    min-width: 20px;\n    text-align: right;\n    color: #999;\n    white-space: nowrap;\n  }\n\n  .CodeMirror-guttermarker {\n    color: black;\n  }\n  .CodeMirror-guttermarker-subtle {\n    color: #999;\n  }\n\n  /* CURSOR */\n\n  .CodeMirror-cursor {\n    border-left: 1px solid black;\n    border-right: none;\n    width: 0;\n  }\n  /* Shown when moving in bi-directional text */\n  .CodeMirror div.CodeMirror-secondarycursor {\n    border-left: 1px solid silver;\n  }\n  .cm-fat-cursor .CodeMirror-cursor {\n    width: auto;\n    border: 0 !important;\n    background: #7e7;\n  }\n  .cm-fat-cursor div.CodeMirror-cursors {\n    z-index: 1;\n  }\n  .cm-fat-cursor-mark {\n    background-color: rgba(20, 255, 20, 0.5);\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n  }\n  .cm-animate-fat-cursor {\n    width: auto;\n    border: 0;\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n    background-color: #7e7;\n  }\n  @-moz-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @-webkit-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n\n  /* Can style cursor different in overwrite (non-insert) mode */\n  .CodeMirror-overwrite .CodeMirror-cursor {\n  }\n\n  .cm-tab {\n    display: inline-block;\n    text-decoration: inherit;\n  }\n\n  .CodeMirror-rulers {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -50px;\n    bottom: 0;\n    overflow: hidden;\n  }\n  .CodeMirror-ruler {\n    border-left: 1px solid #ccc;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n\n  /* DEFAULT THEME */\n\n  .cm-s-default .cm-header {\n    color: blue;\n  }\n  .cm-s-default .cm-quote {\n    color: #090;\n  }\n  .cm-negative {\n    color: #d44;\n  }\n  .cm-positive {\n    color: #292;\n  }\n  .cm-header,\n  .cm-strong {\n    font-weight: bold;\n  }\n  .cm-em {\n    font-style: italic;\n  }\n  .cm-link {\n    text-decoration: underline;\n  }\n  .cm-strikethrough {\n    text-decoration: line-through;\n  }\n\n  .cm-s-default .cm-keyword {\n    color: #708;\n  }\n  .cm-s-default .cm-atom {\n    color: #219;\n  }\n  .cm-s-default .cm-number {\n    color: #164;\n  }\n  .cm-s-default .cm-def {\n    color: #00f;\n  }\n  .cm-s-default .cm-variable,\n  .cm-s-default .cm-punctuation,\n  .cm-s-default .cm-property,\n  .cm-s-default .cm-operator {\n  }\n  .cm-s-default .cm-variable-2 {\n    color: #05a;\n  }\n  .cm-s-default .cm-variable-3,\n  .cm-s-default .cm-type {\n    color: #085;\n  }\n  .cm-s-default .cm-comment {\n    color: #a50;\n  }\n  .cm-s-default .cm-string {\n    color: #a11;\n  }\n  .cm-s-default .cm-string-2 {\n    color: #f50;\n  }\n  .cm-s-default .cm-meta {\n    color: #555;\n  }\n  .cm-s-default .cm-qualifier {\n    color: #555;\n  }\n  .cm-s-default .cm-builtin {\n    color: #30a;\n  }\n  .cm-s-default .cm-bracket {\n    color: #997;\n  }\n  .cm-s-default .cm-tag {\n    color: #170;\n  }\n  .cm-s-default .cm-attribute {\n    color: #00c;\n  }\n  .cm-s-default .cm-hr {\n    color: #999;\n  }\n  .cm-s-default .cm-link {\n    color: #00c;\n  }\n\n  .cm-s-default .cm-error {\n    color: #f00;\n  }\n  .cm-invalidchar {\n    color: #f00;\n  }\n\n  .CodeMirror-composing {\n    border-bottom: 2px solid;\n  }\n\n  /* Default styles for common addons */\n\n  div.CodeMirror span.CodeMirror-matchingbracket {\n    color: #0b0;\n  }\n  div.CodeMirror span.CodeMirror-nonmatchingbracket {\n    color: #a22;\n  }\n  .CodeMirror-matchingtag {\n    background: rgba(255, 150, 0, 0.3);\n  }\n  .CodeMirror-activeline-background {\n    background: #e8f2ff;\n  }\n\n  /* STOP */\n\n  /* The rest of this file contains styles related to the mechanics of\n    the editor. You probably shouldn't touch them. */\n\n  .CodeMirror {\n    position: relative;\n    overflow: hidden;\n    background: white;\n  }\n\n  .CodeMirror-scroll {\n    overflow: scroll !important; /* Things will break if this is overridden */\n    /* 30px is the magic margin used to hide the element's real scrollbars */\n    /* See overflow: hidden in .CodeMirror */\n    margin-bottom: -30px;\n    margin-right: -30px;\n    padding-bottom: 30px;\n    height: 100%;\n    outline: none; /* Prevent dragging from highlighting the element */\n    position: relative;\n  }\n  .CodeMirror-sizer {\n    position: relative;\n    min-height: auto;\n    border-right: 30px solid transparent;\n  }\n\n  /* The fake, visible scrollbars. Used to force redraw during scrolling\n    before actual scrolling happens, thus preventing shaking and\n    flickering artifacts. */\n  .CodeMirror-vscrollbar,\n  .CodeMirror-hscrollbar,\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    position: absolute;\n    z-index: 6;\n    display: none;\n  }\n  .CodeMirror-vscrollbar {\n    right: 0;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n  }\n  .CodeMirror-hscrollbar {\n    bottom: 0;\n    left: 0;\n    overflow-y: hidden;\n    overflow-x: scroll;\n  }\n  .CodeMirror-scrollbar-filler {\n    right: 0;\n    bottom: 0;\n  }\n  .CodeMirror-gutter-filler {\n    left: 0;\n    bottom: 0;\n  }\n\n  .CodeMirror-gutters {\n    position: absolute;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    z-index: 3;\n  }\n  .CodeMirror-gutter {\n    white-space: normal;\n    height: 100%;\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: -30px;\n  }\n  .CodeMirror-gutter-wrapper {\n    position: absolute;\n    z-index: 4;\n    background: none !important;\n    border: none !important;\n  }\n  .CodeMirror-gutter-background {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-elt {\n    position: absolute;\n    cursor: default;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-wrapper ::selection {\n    background-color: transparent;\n  }\n  .CodeMirror-gutter-wrapper ::-moz-selection {\n    background-color: transparent;\n  }\n\n  .CodeMirror-lines {\n    cursor: text;\n    min-height: 1px; /* prevents collapsing before first draw */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    /* Reset some styles that the rest of the page might have set */\n    -moz-border-radius: 0;\n    -webkit-border-radius: 0;\n    border-radius: 0;\n    border-width: 0;\n    background: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n    white-space: pre;\n    word-wrap: normal;\n    line-height: inherit;\n    color: inherit;\n    z-index: 2;\n    position: relative;\n    overflow: visible;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-font-variant-ligatures: contextual;\n    font-variant-ligatures: contextual;\n  }\n  .CodeMirror-wrap pre.CodeMirror-line,\n  .CodeMirror-wrap pre.CodeMirror-line-like {\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    word-break: normal;\n  }\n\n  .CodeMirror-linebackground {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n  }\n\n  .CodeMirror-linewidget {\n    position: relative;\n    z-index: 2;\n    padding: 0.1px; /* Force widget margins to stay inside of the container */\n  }\n\n  .CodeMirror-widget {\n  }\n\n  .CodeMirror-rtl pre {\n    direction: rtl;\n  }\n\n  .CodeMirror-code {\n    outline: none;\n  }\n\n  /* Force content-box sizing for the elements where we expect it */\n  .CodeMirror-scroll,\n  .CodeMirror-sizer,\n  .CodeMirror-gutter,\n  .CodeMirror-gutters,\n  .CodeMirror-linenumber {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n  }\n\n  .CodeMirror-measure {\n    position: absolute;\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .CodeMirror-cursor {\n    position: absolute;\n    pointer-events: none;\n  }\n  .CodeMirror-measure pre {\n    position: static;\n  }\n\n  div.CodeMirror-cursors {\n    visibility: hidden;\n    position: relative;\n    z-index: 3;\n  }\n  div.CodeMirror-dragcursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-focused div.CodeMirror-cursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-selected {\n    background: #d9d9d9;\n  }\n  .CodeMirror-focused .CodeMirror-selected {\n    background: #d7d4f0;\n  }\n  .CodeMirror-crosshair {\n    cursor: crosshair;\n  }\n  .CodeMirror-line::selection,\n  .CodeMirror-line > span::selection,\n  .CodeMirror-line > span > span::selection {\n    background: #d7d4f0;\n  }\n  .CodeMirror-line::-moz-selection,\n  .CodeMirror-line > span::-moz-selection,\n  .CodeMirror-line > span > span::-moz-selection {\n    background: #d7d4f0;\n  }\n\n  .cm-searching {\n    background-color: #ffa;\n    background-color: rgba(255, 255, 0, 0.4);\n  }\n\n  /* Used to force a border model for a node */\n  .cm-force-border {\n    padding-right: 0.1px;\n  }\n\n  @media print {\n    /* Hide the cursor when printing */\n    .CodeMirror div.CodeMirror-cursors {\n      visibility: hidden;\n    }\n  }\n\n  /* See issue #2901 */\n  .cm-tab-wrap-hack:after {\n    content: '';\n  }\n\n  /* Help users use markselection to safely style text background */\n  span.CodeMirror-selectedtext {\n    background: none;\n  }\n"], ["\n  white-space: pre-wrap;\n\n  .CodeMirror {\n    font-family: monospace;\n    height: auto;\n    width: 100%;\n    border-radius: 0.3rem;\n    margin-bottom: 1rem;\n    color: black;\n    direction: ltr;\n  }\n\n  .CodeMirror-lines {\n    padding: 4px 0; /* Vertical padding around content */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    padding: 0 4px; /* Horizontal padding of content */\n  }\n\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    background-color: white; /* The little square between H and V scrollbars */\n  }\n\n  /* GUTTER */\n\n  .CodeMirror-gutters {\n    border-right: 1px solid #ddd;\n    background-color: #f7f7f7;\n    white-space: nowrap;\n  }\n  .CodeMirror-linenumbers {\n  }\n  .CodeMirror-linenumber {\n    padding: 0 3px 0 5px;\n    min-width: 20px;\n    text-align: right;\n    color: #999;\n    white-space: nowrap;\n  }\n\n  .CodeMirror-guttermarker {\n    color: black;\n  }\n  .CodeMirror-guttermarker-subtle {\n    color: #999;\n  }\n\n  /* CURSOR */\n\n  .CodeMirror-cursor {\n    border-left: 1px solid black;\n    border-right: none;\n    width: 0;\n  }\n  /* Shown when moving in bi-directional text */\n  .CodeMirror div.CodeMirror-secondarycursor {\n    border-left: 1px solid silver;\n  }\n  .cm-fat-cursor .CodeMirror-cursor {\n    width: auto;\n    border: 0 !important;\n    background: #7e7;\n  }\n  .cm-fat-cursor div.CodeMirror-cursors {\n    z-index: 1;\n  }\n  .cm-fat-cursor-mark {\n    background-color: rgba(20, 255, 20, 0.5);\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n  }\n  .cm-animate-fat-cursor {\n    width: auto;\n    border: 0;\n    -webkit-animation: blink 1.06s steps(1) infinite;\n    -moz-animation: blink 1.06s steps(1) infinite;\n    animation: blink 1.06s steps(1) infinite;\n    background-color: #7e7;\n  }\n  @-moz-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @-webkit-keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n  @keyframes blink {\n    0% {\n    }\n    50% {\n      background-color: transparent;\n    }\n    100% {\n    }\n  }\n\n  /* Can style cursor different in overwrite (non-insert) mode */\n  .CodeMirror-overwrite .CodeMirror-cursor {\n  }\n\n  .cm-tab {\n    display: inline-block;\n    text-decoration: inherit;\n  }\n\n  .CodeMirror-rulers {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: -50px;\n    bottom: 0;\n    overflow: hidden;\n  }\n  .CodeMirror-ruler {\n    border-left: 1px solid #ccc;\n    top: 0;\n    bottom: 0;\n    position: absolute;\n  }\n\n  /* DEFAULT THEME */\n\n  .cm-s-default .cm-header {\n    color: blue;\n  }\n  .cm-s-default .cm-quote {\n    color: #090;\n  }\n  .cm-negative {\n    color: #d44;\n  }\n  .cm-positive {\n    color: #292;\n  }\n  .cm-header,\n  .cm-strong {\n    font-weight: bold;\n  }\n  .cm-em {\n    font-style: italic;\n  }\n  .cm-link {\n    text-decoration: underline;\n  }\n  .cm-strikethrough {\n    text-decoration: line-through;\n  }\n\n  .cm-s-default .cm-keyword {\n    color: #708;\n  }\n  .cm-s-default .cm-atom {\n    color: #219;\n  }\n  .cm-s-default .cm-number {\n    color: #164;\n  }\n  .cm-s-default .cm-def {\n    color: #00f;\n  }\n  .cm-s-default .cm-variable,\n  .cm-s-default .cm-punctuation,\n  .cm-s-default .cm-property,\n  .cm-s-default .cm-operator {\n  }\n  .cm-s-default .cm-variable-2 {\n    color: #05a;\n  }\n  .cm-s-default .cm-variable-3,\n  .cm-s-default .cm-type {\n    color: #085;\n  }\n  .cm-s-default .cm-comment {\n    color: #a50;\n  }\n  .cm-s-default .cm-string {\n    color: #a11;\n  }\n  .cm-s-default .cm-string-2 {\n    color: #f50;\n  }\n  .cm-s-default .cm-meta {\n    color: #555;\n  }\n  .cm-s-default .cm-qualifier {\n    color: #555;\n  }\n  .cm-s-default .cm-builtin {\n    color: #30a;\n  }\n  .cm-s-default .cm-bracket {\n    color: #997;\n  }\n  .cm-s-default .cm-tag {\n    color: #170;\n  }\n  .cm-s-default .cm-attribute {\n    color: #00c;\n  }\n  .cm-s-default .cm-hr {\n    color: #999;\n  }\n  .cm-s-default .cm-link {\n    color: #00c;\n  }\n\n  .cm-s-default .cm-error {\n    color: #f00;\n  }\n  .cm-invalidchar {\n    color: #f00;\n  }\n\n  .CodeMirror-composing {\n    border-bottom: 2px solid;\n  }\n\n  /* Default styles for common addons */\n\n  div.CodeMirror span.CodeMirror-matchingbracket {\n    color: #0b0;\n  }\n  div.CodeMirror span.CodeMirror-nonmatchingbracket {\n    color: #a22;\n  }\n  .CodeMirror-matchingtag {\n    background: rgba(255, 150, 0, 0.3);\n  }\n  .CodeMirror-activeline-background {\n    background: #e8f2ff;\n  }\n\n  /* STOP */\n\n  /* The rest of this file contains styles related to the mechanics of\n    the editor. You probably shouldn't touch them. */\n\n  .CodeMirror {\n    position: relative;\n    overflow: hidden;\n    background: white;\n  }\n\n  .CodeMirror-scroll {\n    overflow: scroll !important; /* Things will break if this is overridden */\n    /* 30px is the magic margin used to hide the element's real scrollbars */\n    /* See overflow: hidden in .CodeMirror */\n    margin-bottom: -30px;\n    margin-right: -30px;\n    padding-bottom: 30px;\n    height: 100%;\n    outline: none; /* Prevent dragging from highlighting the element */\n    position: relative;\n  }\n  .CodeMirror-sizer {\n    position: relative;\n    min-height: auto;\n    border-right: 30px solid transparent;\n  }\n\n  /* The fake, visible scrollbars. Used to force redraw during scrolling\n    before actual scrolling happens, thus preventing shaking and\n    flickering artifacts. */\n  .CodeMirror-vscrollbar,\n  .CodeMirror-hscrollbar,\n  .CodeMirror-scrollbar-filler,\n  .CodeMirror-gutter-filler {\n    position: absolute;\n    z-index: 6;\n    display: none;\n  }\n  .CodeMirror-vscrollbar {\n    right: 0;\n    top: 0;\n    overflow-x: hidden;\n    overflow-y: scroll;\n  }\n  .CodeMirror-hscrollbar {\n    bottom: 0;\n    left: 0;\n    overflow-y: hidden;\n    overflow-x: scroll;\n  }\n  .CodeMirror-scrollbar-filler {\n    right: 0;\n    bottom: 0;\n  }\n  .CodeMirror-gutter-filler {\n    left: 0;\n    bottom: 0;\n  }\n\n  .CodeMirror-gutters {\n    position: absolute;\n    left: 0;\n    top: 0;\n    min-height: 100%;\n    z-index: 3;\n  }\n  .CodeMirror-gutter {\n    white-space: normal;\n    height: 100%;\n    display: inline-block;\n    vertical-align: top;\n    margin-bottom: -30px;\n  }\n  .CodeMirror-gutter-wrapper {\n    position: absolute;\n    z-index: 4;\n    background: none !important;\n    border: none !important;\n  }\n  .CodeMirror-gutter-background {\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-elt {\n    position: absolute;\n    cursor: default;\n    z-index: 4;\n  }\n  .CodeMirror-gutter-wrapper ::selection {\n    background-color: transparent;\n  }\n  .CodeMirror-gutter-wrapper ::-moz-selection {\n    background-color: transparent;\n  }\n\n  .CodeMirror-lines {\n    cursor: text;\n    min-height: 1px; /* prevents collapsing before first draw */\n  }\n  .CodeMirror pre.CodeMirror-line,\n  .CodeMirror pre.CodeMirror-line-like {\n    /* Reset some styles that the rest of the page might have set */\n    -moz-border-radius: 0;\n    -webkit-border-radius: 0;\n    border-radius: 0;\n    border-width: 0;\n    background: transparent;\n    font-family: inherit;\n    font-size: inherit;\n    margin: 0;\n    white-space: pre;\n    word-wrap: normal;\n    line-height: inherit;\n    color: inherit;\n    z-index: 2;\n    position: relative;\n    overflow: visible;\n    -webkit-tap-highlight-color: transparent;\n    -webkit-font-variant-ligatures: contextual;\n    font-variant-ligatures: contextual;\n  }\n  .CodeMirror-wrap pre.CodeMirror-line,\n  .CodeMirror-wrap pre.CodeMirror-line-like {\n    word-wrap: break-word;\n    white-space: pre-wrap;\n    word-break: normal;\n  }\n\n  .CodeMirror-linebackground {\n    position: absolute;\n    left: 0;\n    right: 0;\n    top: 0;\n    bottom: 0;\n    z-index: 0;\n  }\n\n  .CodeMirror-linewidget {\n    position: relative;\n    z-index: 2;\n    padding: 0.1px; /* Force widget margins to stay inside of the container */\n  }\n\n  .CodeMirror-widget {\n  }\n\n  .CodeMirror-rtl pre {\n    direction: rtl;\n  }\n\n  .CodeMirror-code {\n    outline: none;\n  }\n\n  /* Force content-box sizing for the elements where we expect it */\n  .CodeMirror-scroll,\n  .CodeMirror-sizer,\n  .CodeMirror-gutter,\n  .CodeMirror-gutters,\n  .CodeMirror-linenumber {\n    -moz-box-sizing: content-box;\n    box-sizing: content-box;\n  }\n\n  .CodeMirror-measure {\n    position: absolute;\n    width: 100%;\n    height: 0;\n    overflow: hidden;\n    visibility: hidden;\n  }\n\n  .CodeMirror-cursor {\n    position: absolute;\n    pointer-events: none;\n  }\n  .CodeMirror-measure pre {\n    position: static;\n  }\n\n  div.CodeMirror-cursors {\n    visibility: hidden;\n    position: relative;\n    z-index: 3;\n  }\n  div.CodeMirror-dragcursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-focused div.CodeMirror-cursors {\n    visibility: visible;\n  }\n\n  .CodeMirror-selected {\n    background: #d9d9d9;\n  }\n  .CodeMirror-focused .CodeMirror-selected {\n    background: #d7d4f0;\n  }\n  .CodeMirror-crosshair {\n    cursor: crosshair;\n  }\n  .CodeMirror-line::selection,\n  .CodeMirror-line > span::selection,\n  .CodeMirror-line > span > span::selection {\n    background: #d7d4f0;\n  }\n  .CodeMirror-line::-moz-selection,\n  .CodeMirror-line > span::-moz-selection,\n  .CodeMirror-line > span > span::-moz-selection {\n    background: #d7d4f0;\n  }\n\n  .cm-searching {\n    background-color: #ffa;\n    background-color: rgba(255, 255, 0, 0.4);\n  }\n\n  /* Used to force a border model for a node */\n  .cm-force-border {\n    padding-right: 0.1px;\n  }\n\n  @media print {\n    /* Hide the cursor when printing */\n    .CodeMirror div.CodeMirror-cursors {\n      visibility: hidden;\n    }\n  }\n\n  /* See issue #2901 */\n  .cm-tab-wrap-hack:after {\n    content: '';\n  }\n\n  /* Help users use markselection to safely style text background */\n  span.CodeMirror-selectedtext {\n    background: none;\n  }\n"])),
      Fr = C(function (e) {
    var n = e.input,
        t = (e.plugins, e.frame),
        r = A(e, ["input", "plugins", "frame"]),
        o = f.useContext(s.ThemeContext) || {},
        i = tr(n, Dr, t, o);
    return f.createElement(f.Fragment, null, f.createElement("link", {
      rel: "stylesheet",
      href: "https://codemirror.net/lib/codemirror.css"
    }), f.createElement("div", _z({}, r, {
      ref: i
    })));
  })(Lr = Lr || S(["\n  ", "\n"], ["\n  ", "\n"]), Br);
  e.AsyncSelect = function (e) {
    var n = e.dynamicOptions,
        t = void 0 !== n && n,
        r = A(e, ["dynamicOptions"]),
        o = f.useState(0),
        i = o[0],
        a = o[1];
    return f.useEffect(function () {
      t && a(i + 1);
    }, [r.loadOptions, t, i]), f.createElement(l.Async, _z({
      styles: fe,
      theme: function theme(e) {
        return _z({}, e, {
          borderRadius: 4.8,
          colors: _z({}, e.colors, {
            primary: "#333",
            primary50: "#dedede"
          })
        });
      }
    }, r, {
      key: "async-" + i,
      components: _z({
        ClearIndicator: ie,
        DropdownIndicator: te,
        MultiValueRemove: oe,
        IndicatorSeparator: re
      }, r.components)
    }));
  }, e.ColorPicker = ee, e.Cover = J, e.ImageUpload = function (e) {
    var n = e.onDrop,
        t = e.onClear,
        r = e.value,
        o = e.previewSrc,
        i = p.useDropzone({
      accept: "image/*",
      onDrop: n
    }),
        a = i.getRootProps,
        s = i.getInputProps,
        l = i.isDragActive,
        c = i.isDragAccept,
        d = i.isDragReject;
    return f.createElement(xe, _z({}, a({
      isDragActive: l,
      isDragAccept: c,
      isDragReject: d
    })), f.createElement("input", _z({}, s())), r ? f.createElement(Ee, null, f.createElement(Me, {
      src: o
    }), t && f.createElement(_e, {
      onClick: function onClick(e) {
        e.stopPropagation(), t();
      }
    }, f.createElement(u.TrashIcon, null))) : f.createElement(Ce, null, "Drag 'n' drop some files here,", f.createElement("br", null), "or click to select files"));
  }, e.Input = N, e.InputCss = P, e.Popover = Y, e.Select = function (n) {
    var e = f.useMemo(function () {
      return (n.options || []).map(function (e) {
        return 0 <= ["string", "number"].indexOf(typeof e) ? {
          label: e,
          value: e
        } : e;
      });
    }, [n.options]),
        t = f.useMemo(function () {
      return e.find(function (e) {
        return e.value === n.value;
      });
    }, [e, n.value]),
        r = f.useCallback(function (e) {
      return e ? Array.isArray(e) ? n.onChange(e[0] ? e[0].value : "") : void n.onChange(e.value) : n.onChange("");
    }, [n]);
    return f.useEffect(function () {
      t || n.isLoading || (n.isClearable ? n.value && r(null) : r(e[0]));
    }, [n.value, n.isLoading, n.isClearable, t, r, e]), f.createElement(M, _z({
      styles: fe,
      theme: function theme(e) {
        return _z({}, e, {
          borderRadius: 4.8,
          colors: _z({}, e.colors, {
            primary: "#333",
            primary50: "#dedede"
          })
        });
      }
    }, n, {
      options: e,
      value: t,
      onChange: r,
      components: _z({
        ClearIndicator: ie,
        DropdownIndicator: te,
        MultiValueRemove: oe,
        IndicatorSeparator: re
      }, n.components)
    }));
  }, e.Swatch = Z, e.TextArea = $, e.TextField = q, e.Toggle = function (e) {
    var n = !(!e.input.value && !e.input.checked);
    return f.createElement(de, null, f.createElement(me, _z({
      id: e.name,
      type: "checkbox"
    }, e.input)), f.createElement(ue, {
      htmlFor: e.name,
      role: "switch",
      disabled: e.disabled
    }, f.createElement(pe, {
      checked: n
    }, f.createElement("span", null))));
  }, e.Wysiwyg = Fr, Object.defineProperty(e, "__esModule", {
    value: !0
  });
});